import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import * as moment from "moment";
import * as _ from "lodash";

import { DateLocaleService } from "../services/date-locale-service";
import { EntityCharDataService } from "../services/entity-char-data-service";
import { DataSecurityService } from "../services/data-security-service";
import { AclService } from "../services/acl-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";
import { DateCalcService } from "../services/date-calc-service";
import { LocalCacheService } from "../services/local-cache-service";
import { VariesByCatalogService } from "../services/varies-by-catalog-service";
import { DocumentEntityService } from "../services/document-entity-service";
import { NotifyService } from "../services/notify-service";
import { CurrencyConversionService } from "../services/currency-conversion-service";
import { IRLCharDataElementScope } from "../ts/rlAdmin.models";
import { RLDataDisplayMultiDate, RLDataEditMultiDate } from "../directives/chardata/multi-date";

/* directive for Char Data Table */
export function RLCharDataTableDirective() {
    var directive: ng.IDirective = {
        restrict: "EA",
        transclude: true,
        //require: ["^?form"],
        template: require("/assets/app/templates/chardata/char-data-table.html"),
        scope: {
            entityData: "=", // json representation of entity/template/chardata
            //visibility: "=", // set the visibility of entire table
            editMode: "=",  // boolean,
            submitted: "=?",
            parentCurrencyCharData: "=?",
            matchCurrencyCharData: "=?",
            requiredOnly: "=?",
            bulkEdit: "=?",
            parentEntityID: "@?parentEntityId"
        },
        link: (scope: IRLCharDataTableScope, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes, controllers: any, transclude: ng.ITranscludeFunction) => {
            var targetScope = scope.$parent;
            //transclude(targetScope, (clone) => {
            //    for (var i = 0; i < clone.length; i++) {
            //        var child = clone[i];
            //        if ((child.tagName || "").toLowerCase() == "table-bottom") {
            //            scope.hasBottom = true;
            //        }
            //    }
            //});
        },
        controller: RLCharDataTableController,
        controllerAs: "tableVM"
    };
    return directive;
}
/* controller for RLCharDataElementDirective */
export class RLCharDataTableController {
    static $inject = ["$scope", "$timeout", "$log", "dateLocaleService", "entityCharDataService", "dataSecurityService", "aclService"];

    createMode: boolean;
    groups: Models.ITemplateCharacteristicGroup[];
    groupCmds: { [groupID: number]: Models.ICharacteristicMetaData[] };
    //canWriteCMD: _.Dictionary<boolean>;
    //canCreateCMD: _.Dictionary<boolean>;
    //cmdAcls: _.Dictionary<string>;

    //ngModels: { [modelName: string]: ng.INgModelController };
    groupCollapsed: { [groupID: number]: boolean };

    crossCharValueGroupTriggeredHandlers: { (charValueGroupIDs: string[], emptyId: boolean): void; }[];

    currencyCharacteristics: { [charID: number]: Models.ICharDataValue };
    defaultCurrencyCharData: Models.ICharDataValue;
    acls: string[];
    templateGroupID: number;

    entityDataCtrl: RLCharDataEntityDataController;

    constructor(private $scope: IRLCharDataTableScope,
        private $timeout: ng.ITimeoutService,
        private $log: ng.ILogService,
        private dateLocaleService: DateLocaleService,
        private entityCharDataService: EntityCharDataService,
        private dataSecurityService: DataSecurityService,
        private aclService: AclService) {
        $scope.hasBottom = false;
        $scope.submitted = $scope.submitted || false;
        this.groups = [];
        this.groupCmds = {};
        //this.ngModels = {};
        this.crossCharValueGroupTriggeredHandlers = [];
        this.groupCollapsed = {};
        this.currencyCharacteristics = {};
        this.defaultCurrencyCharData = null;

        //load acls
        this.acls = this.aclService.acls;

        var entityWatchFunc: () => string = () => { return ($scope.entityData != null) ? $scope.entityData.entityID : ""; };
        var entityUpdatedFunc = (newValue: string, oldValue: string) => {
            if (!_.isEmpty(newValue)) {
                var id = Utils.IdBuilder.splitEntityID(newValue);
                this.createMode = (id.recID == -1);
            }
        };

        $scope.$watch(entityWatchFunc, entityUpdatedFunc);

        type ICharDataWatch = [string[], boolean, boolean, string, number[]];
        var charIDMap = (charDataCollection: Models.ICharDataCollection) => charDataCollection != null ? _(charDataCollection.charDatas).map((value: Models.ICharDataValue[]) => value.map(cd => cd.charID)).flattenDeep<number>().uniq().sort().value() : [];
        var charDataWatchFunc = (): ICharDataWatch => [
            this.acls,
            $scope.editMode,
            this.createMode,
            this.getTemplateID($scope.entityData),
            charIDMap($scope.entityData)];

        var charDataUpdateFunc = (newValue: ICharDataWatch, oldValue: ICharDataWatch) => {
            var acls = newValue[0];
            var editMode = newValue[1];
            this.groups = [];
            this.groupCmds = {};
            //this.cmdAcls = {};
            //this.canWriteCMD = {};
            //this.canCreateCMD = {};

            if (_.any(newValue[0]) && $scope.entityData != null) {
                //this.cmdAcls = this.dataSecurityService.getCMDAcls($scope.entityData.templateMetaData);
                var cmds = this.dataSecurityService.filterVisibleGroupsCharacteristics(newValue[0], $scope.entityData.templateMetaData, $scope.entityData.charDatas, editMode);
                if (this.createMode) {
                    cmds = cmds.filter((cmd) => Utils.AclUtil.hasCreateAccess(this.aclService.acls, cmd.acl) && (cmd.systemIndicator != -1 || cmd.tagLabel == "entity_title"));
                }
                var groups: Models.ITemplateCharacteristicGroup[] = [];
                var groupCmds: _.Dictionary<Models.ICharacteristicMetaData[]> = {};
                $scope.entityData.templateMetaData.groups.forEach((group) => {
                    var groupCmds2 = cmds.filter(cmd => cmd.groupID == group.groupID);
                    if (_.any(groupCmds2)) {
                        groups.push(group);
                        groupCmds[group.groupID] = _.sortBy(groupCmds2, cmd => cmd.sequenceNumber);
                    }
                });
                this.groups = _.sortBy(groups, g => g.sequenceNumber);
                this.groupCmds = groupCmds;

                if (_.keys(this.groupCollapsed).length == 0) {
                    //in edit mode, expand all groups
                    this.groupCollapsed = {};
                    //if group is configured to set to not expand then collapse the group in editmode
                    _.forEach($scope.entityData.templateMetaData.groups, (grp) => {
                        if (grp.expGroupIndicator == 0) {
                            this.groupCollapsed[grp.groupID] = true;
                        }
                        else {
                            this.groupCollapsed[grp.groupID] = false;
                        }
                    });
                }
            }
        };

        $scope.$watch(charDataWatchFunc, charDataUpdateFunc, true);

        $scope.$watch(() => [$scope.parentCurrencyCharData, $scope.entityData != null ? $scope.entityData.charDatas : null],
            (newValue, oldValue) => {

                this.currencyCharacteristics = {};

                if ($scope.entityData != null) {
                    var charDataCollection = $scope.entityData;
                    var currencyChars = _.filter(charDataCollection.templateMetaData.characteristicMetaDatas, (cmd) => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.currency);

                    currencyChars.forEach((cmd) => {
                        var currencyCharData: Models.ICharDataValue = Utils.CharUtil.GetCurrencyCharData(charDataCollection, cmd.groupID);
                        this.currencyCharacteristics[cmd.characteristicID] = currencyCharData || $scope.parentCurrencyCharData || this.defaultCurrencyCharData;
                    });
                }
            }, true);
    }

    GetEntityID() {
        return this.$scope.entityData.entityID;
    }

    ShowRequired(cmd) {
        if (this.$scope.requiredOnly) {
            if (cmd.requiredIndicator == 1)
                return true;
        }
        else if (!this.$scope.requiredOnly) {
            return true;
        }

        return false;
    }

    ShowRequiredGroup(group: Models.ITemplateCharacteristicGroup) {

        //cmds: Models.ICharacteristicMetaData[];

        var cmds = this.groupCmds[group.groupID];

        if (cmds != null) {
            var requiredCmds = _.filter(cmds, (cmd) => cmd.requiredIndicator == 1);

            if (this.$scope.requiredOnly && requiredCmds.length > 0) {
                return true;
            }
            else if (!this.$scope.requiredOnly) {
                return true;
            }
        }

        return false;
    }

    private cmdHasData(cmd: Models.ICharacteristicMetaData) {
        var charDatas = this.$scope.entityData.charDatas;
        if (charDatas == null || charDatas[cmd.tagLabel] == null) {
            return false;
        }

        var values = charDatas[cmd.tagLabel];
        return _(values).any((charData) => { return !_.isEmpty(charData.value) || charData.valueID != null; });
    }

    private getTemplateID(entityData: Models.ICharDataCollection) {
        if (entityData != null && !_.isEmpty(entityData)) {
            var tmd = entityData.templateMetaData;
            this.templateGroupID = tmd.template.templateGroupID;
            return Utils.IdBuilder.buildTemplateID(tmd.divID, tmd.charTypeID, tmd.templateID);
        }
        return "";
    }

    CrossCharValueGroupsTriggered(charValueGroupIDs: string[], isEmpty: boolean = false) {
        for (var i = 0; i < this.crossCharValueGroupTriggeredHandlers.length; i++) {
            this.crossCharValueGroupTriggeredHandlers[i](charValueGroupIDs, isEmpty);
        }
    }

    OnCrossCharValueGroupsTriggered(handler: ((charValueGroupIDs: string[]) => void) | ((triggerGroupIDs: string[], isEmpty: boolean) => void)) {
        this.crossCharValueGroupTriggeredHandlers.push(handler);
    }

    OffCrossCharValueGroupsTriggered(handler: ((charValueGroupIDs: string[]) => void) | ((triggerGroupIDs: string[], isEmpty: boolean) => void)) {
        _.remove(this.crossCharValueGroupTriggeredHandlers, (f) => f == handler);
    }

    ToggleOpen(groupID: number) {
        this.groupCollapsed[groupID] = !(!!(this.groupCollapsed[groupID]));
    }

    SetEditMode(editMode: boolean) {
        this.$scope.editMode = editMode;
    }
}

interface IRLCharDataTableScope extends ng.IScope {
    hasBottom: boolean;
    entityData: Models.ICharDataCollection;
    //visibility: number;
    editMode: boolean;
    submitted?: boolean;
    parentCurrencyCharData?: Models.ICharDataValue;
    matchCurrencyCharData?: Models.ICharDataValue;
    requiredOnly?: boolean;
    bulkEdit?: boolean;
    parentEntityID?: string;
    bulkUpdate?: boolean;
}

RLCharDataTableBottomTransclude.$inject = ["$compile"];
export function RLCharDataTableBottomTransclude($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transclude: ng.ITranscludeFunction) => {
            var targetScope: ng.IScope = scope.$parent;
            transclude(targetScope, (clone) => {
                element.empty();
                _.forEach($("tr", clone), (el) => {
                    var newEl = angular.element(el).clone();
                    var compiled = $compile(newEl);
                    element.append(newEl);
                    compiled(targetScope);
                });
            });
        }
    };
    return directive;
}

/* directive for each CMD elements edit/display */
RLCharDataElementDirective.$inject = ["$q", "$log", "$timeout", "dateLocaleService", "entityService", "entityConfigService"];
export function RLCharDataElementDirective($q: ng.IQService, $log: ng.ILogService, $timeout: ng.ITimeoutService, dateLocaleService: DateLocaleService, entityService: EntityService, entityConfigService: EntityConfigService) {
    var yearRegex = new RegExp("^(?:\\d{4})$");
    var urlRegex = /^((https?|s?ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
    var numberRegex = /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/;
    var currencyRegex = /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d{2})?$/;
    var dateRegex = /^(0[1-9]|[1-9]|1[0-2])\/(0[1-9]|[1-9]|1\d|2\d|3[01])\/(19[0-9]{2}|[2-9][0-9]{3})$/;
    var dateIsoRegex = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/;
    var emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
    var timecodeRegex = new RegExp("^\\d{2}:\\d{2}:\\d{2}$");


    var hasDateMath = (cd: Models.ICharDataValue) => {
        if (_.isNull(cd)) {
            return false;
        }
        if (cd.ext != null && cd.ext.dateMath != null) {
            var dateMaths = cd.ext.dateMath.calcs.filter(calc => cd.ext.dateMath.calcsChangeTracking[calc.dateMathCalcID] != -1);
            return _.any(dateMaths);
        }
        return false;
    };

    var modelIsEmptyFunc = (value: Models.ICharDataValue[]) => {
        if (_.isNull(value)) {
            return true;
        }
        if (_.isArray(value)) {
            var firstCharData = _.first(value);
            return <boolean>(firstCharData == null || Utils.JsonUtil.Parse(firstCharData.value, {}) == {} || (_.isEmpty(firstCharData.value) && !_.isNumber(firstCharData.valueID) && !hasDateMath(firstCharData)));
        }
        return false;
    };

    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/char-data-element.html"),
        require: ["ngModel", "rlCharDataElement", "^?rlCharDataTable", "^?rlCharDataEntityData", "?^rlCharDataTableEntityData"],
        priority: -1,
        replace: true,
        scope: {
            cmd: "=rlCharDataElement", // json characteristic meta data
            charDatas: "=ngModel", // json characteristic datas
            editMode: "=editMode", // bool for edit/display mode
            searchMode: "=?searchMode", // bool for search mode
            currencySymbolCharData: "=?", // currency Symbol for propagation from table level
            parentCurrencyCharData: "=?", // currency symbol from parent entity for enforcing matching currencies
            matchCurrencyCharData: "=?", // currency symbol from parent entity for enforcing matching currencies
            createMode: "=createMode",
            submitted: "=?",
            templateID: "=?templateId", //templateID to be used to get alerts or anything else needed
            entityID: "=?entityId", //entityID to be used to add/edit alerts or anything else needed
            bulkEdit: "=", //if BulkEdit, then hide panel for date settings stuff  
            lovDelimiter: '@?',
            disableControlValidation: "=?",
            parentEntityID: "=?parentEntityId",
            bulkUpdate: "=",
            acl: "=?acl",
            commonCmds: "<?",
            firstCatalogItem: "<?",
            firstCatalogItemCharDataCol: "<?"
        },
        link: (scope: IRLCharDataElementScope, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes, controllers: any, transclude: ng.ITranscludeFunction) => {

            var ngModelCtrl: ng.INgModelController = controllers[0];
            var rlCharDataElementCtrl: RLCharDataElementController = controllers[1];
            var rlCharDataTableCtrl: RLCharDataTableController = controllers[2];
            if (rlCharDataTableCtrl != null && controllers[4] != null) {
                var rlCharDataEntityDataCtrl: RLCharDataEntityDataController = controllers[4];
            }
            else {
                var rlCharDataEntityDataCtrl: RLCharDataEntityDataController = controllers[3];
            }

            var tagLabel = scope.cmd.tagLabel;
            ngModelCtrl.$name = tagLabel;
            ngModelCtrl.$isEmpty = modelIsEmptyFunc;
            ngModelCtrl.$overrideModelOptions({ allowInvalid: true, updateOn: "default" });

            if (_.isNull(scope.disableControlValidation) || _.isUndefined(scope.disableControlValidation)) {
                scope.disableControlValidation = false;
            }

            if (rlCharDataTableCtrl != null) {
                rlCharDataElementCtrl.hasTable = true;
            }

            if (rlCharDataEntityDataCtrl != null) {
                rlCharDataEntityDataCtrl.RegisterModel(ngModelCtrl);
                rlCharDataElementCtrl.entityDataCtrl = rlCharDataEntityDataCtrl;
            }

            if (scope.bulkEdit) {
                rlCharDataElementCtrl.hasTable = true;
            }

            if (scope.lovDelimiter) {
                rlCharDataElementCtrl.lovDelimiter = scope.lovDelimiter;
            }

            // update ngModel whenever the actual charDatas array is refreshed
            scope.$watch("charDatas", (newValue: Models.ICharDataValue[], oldValue: Models.ICharDataValue[]) => {
                var oldPristine = ngModelCtrl.$pristine;
                ngModelCtrl.$pristine = false;
                ngModelCtrl.$setViewValue(newValue);
                ngModelCtrl.$pristine = oldPristine;
                if (!_.any(scope.charDatas)) {
                    rlCharDataElementCtrl.EnsureLovData()
                        .then(() => {
                            rlCharDataElementCtrl.EnsureFirstCharData();
                            scope.firstCharData = scope.charDatas[0];
                        });
                } else {
                    scope.firstCharData = scope.charDatas[0];
                    if (scope.cmd.requiredIndicator == 2) {
                        if (!_.isEmpty(scope.firstCharData.value)) {
                            $(instanceElement).removeClass("has-warning");
                        }
                        else {
                            $(instanceElement).addClass("has-warning");
                        }
                    }
                }
            });

            // update ngModel whenever values of the charDatas array are changed
            scope.$watch("charDatas", (newValue: Models.ICharDataValue[], oldValue: Models.ICharDataValue[]) => {
                if (newValue != oldValue) {
                    ngModelCtrl.$modelValue = null;
                    ngModelCtrl.$setViewValue(newValue);
                    if (scope.cmd.requiredIndicator == 2) {
                        if (!_.isEmpty(newValue[0].value)) {
                            $(instanceElement).removeClass("has-warning");
                        }
                        else {
                            $(instanceElement).addClass("has-warning");
                        }
                    }
                    ngModelCtrl.$validate();
                }
            }, true);

            scope.$watch(() => scope.disableControlValidation, (newValue, oldValue) => {
                if (newValue != oldValue) {
                    ngModelCtrl.$validate();
                }
            }, true);

            var requiredValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    valid = !ngModelCtrl.$isEmpty(charDatas);
                }

                return valid;
            }

            var patternValidator = (regex: RegExp) => {
                return (charDatas: Models.ICharDataValue[]) => {
                    var valid = true;

                    if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                        _.forEach(charDatas, (charData) => {
                            if (!_.isEmpty(charData.value || "") && !regex.test(charData.value || "")) {
                                valid = false;
                            }
                        });
                    }

                    return valid;
                };
            };


            var moneyValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    _.forEach(charDatas, (charData) => {
                        var value = charData.value || "";
                        if (!_.isEmpty(value)) {
                            var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(value, {});
                            valid = moneyValue.divAmt != null && moneyValue.locAmt != null && moneyValue.locCur != null && moneyValue.locSym != null;
                        } 
                    });
                }
                return valid;
            };

            var dateValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    _.forEach(charDatas, (charData) => {
                        var value = charData.value || "";
                        if (!_.isEmpty(value)) {

                            if (scope.searchMode) {

                            } else {
                                if (!dateRegex.test(value) && !dateIsoRegex.test(value)) {
                                    valid = false;
                                }
                                else {
                                    var dateMoment = dateLocaleService.parseStorageMoment(value);
                                    if (!dateMoment.isValid()) {
                                        valid = false;
                                    }
                                }
                            }
                        }
                    });
                }

                return valid;
            };

            var percentageValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    _.forEach(charDatas, (charData) => {
                        var value = charData.value || "";
                        if (!_.isEmpty(value)) {
                            var numValue = parseFloat(value);
                            if (!numberRegex.test(value) || Math.abs(numValue) > 100) {
                                valid = false;
                            }
                        }
                    });
                }

                return valid;
            };

            var timeCodeValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    _.forEach(charDatas, (charData) => {
                        var value = charData.value || "";
                        if (!_.isEmpty(value) && !(timecodeRegex.test(value) || value == "__:__:__")) {
                            valid = false;
                        }
                    });
                }

                return valid;
            };

            var currencySymbolValidator = (charDatas: Models.ICharDataValue[]) => {
                var valid = true;

                if (!scope.disableControlValidation && rlCharDataElementCtrl.editMode) {
                    _.forEach(charDatas, (charData) => {
                        var currencyValueID = charData.valueID || -1;
                        if (scope.matchCurrencyCharData != null) {
                            valid = scope.matchCurrencyCharData.valueID == currencyValueID;
                        }
                    });
                }

                return valid;
            };

            var uniqueTitleValidator = function (modelValue, viewValue) {
                if (!scope.disableControlValidation && (scope.editMode || scope.createMode) && rlCharDataElementCtrl.editMode) {
                    var titleCharDataValue = modelValue || viewValue;
                    var titleValue = "";
                    if (titleCharDataValue.length > 1) {
                        titleValue = _.pluck(titleCharDataValue, "value").join("|");
                    }
                    else {
                        titleValue = titleCharDataValue[0].value ? titleCharDataValue[0].value : "";
                    }

                    if (scope.createMode && _.isEmpty(titleValue)) {
                        return $q.resolve();
                    }

                    var recordID: number;
                    if (!_.isEmpty(scope.entityID)) {
                        recordID = Utils.IdBuilder.splitEntityID(scope.entityID).recID;
                    }
                    else {
                        recordID = -1;
                    }

                    var parentCharTypeID = -1;
                    var parentRecID = -1;
                    if (scope.parentEntityID != undefined) {
                        var parentEntityID = Utils.IdBuilder.splitEntityID(scope.parentEntityID);
                        parentCharTypeID = parentEntityID.charTypeID;
                        parentRecID = parentEntityID.recID;
                    }
                    var templateID = 0;
                    if (scope.templateID != undefined) {
                        templateID = scope.templateID;
                    }

                    if (!_.isEmpty(titleValue)) {
                        return entityService.searchForUniqueTitle(scope.cmd.charTypeID, templateID, scope.cmd.tagLabel, scope.cmd.dataTypeID, titleValue, recordID, parentCharTypeID, parentRecID, scope.cmd.characteristicID)
                            .then((result) => {
                                if (!result.data) {
                                    return $q.reject();
                                }
                                else {
                                    return $q.resolve();
                                }
                            });
                    } else {
                        return $q.resolve();
                    }
                }
                else {
                    return $q.resolve();
                }
            };

            var setupValidation = () => {
                var cmd = scope.cmd;

                if (cmd.requiredIndicator == 1 && !scope.bulkUpdate) {
                    ngModelCtrl.$validators["required"] = requiredValidator;
                }

                if (cmd.dataTypeID == 3 && cmd.charValueSourceID && cmd.systemIndicator == Consts.SystemIndicators.Currency) {
                    ngModelCtrl.$validators["currencySymbol"] = currencySymbolValidator;
                }

                if ((cmd.tagLabel == "entity_title" && cmd.charTypeID == Consts.CharTypeIDs.property) || (cmd.tagLabel == "entity_title" && cmd.charTypeID == Consts.CharTypeIDs.document && rlCharDataTableCtrl.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) || (cmd.charTypeID == Consts.CharTypeIDs.document && cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file)) {
                    var parentCharTypeID = -1;
                    var parentRecID = -1;
                    if (scope.parentEntityID != undefined) {
                        var parentEntityID = Utils.IdBuilder.splitEntityID(scope.parentEntityID);
                        parentCharTypeID = parentEntityID.charTypeID;
                        parentRecID = parentEntityID.recID;
                    }

                    if (parentCharTypeID == Consts.CharTypeIDs.property && parentRecID > 0) {
                        ngModelCtrl.$asyncValidators["uniqueTitle"] = uniqueTitleValidator;
                    }
                    else {
                        if (cmd.charTypeID == Consts.CharTypeIDs.document && cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file) {
                            ngModelCtrl.$asyncValidators["uniqueTitle"] = uniqueTitleValidator;
                        }
                        else if (cmd.tagLabel == "entity_title" && cmd.charTypeID == Consts.CharTypeIDs.document && rlCharDataTableCtrl.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) {
                            ngModelCtrl.$asyncValidators["uniqueTitle"] = uniqueTitleValidator;
                        }
                        else {
                            entityConfigService.getUniqueTitleIndicator(cmd.charTypeID, cmd.characteristicID, scope.templateID)
                                .then((result) => {
                                    if (result.success) {
                                        if (result.data) {
                                            ngModelCtrl.$asyncValidators["uniqueTitle"] = uniqueTitleValidator;
                                        }
                                    }
                                });
                        }
                    }
                }

                switch (cmd.dataTypeID) {
                    case 1:
                        ngModelCtrl.$validators["year"] = patternValidator(yearRegex);
                        break;
                    case 2:
                        ngModelCtrl.$validators["url"] = patternValidator(urlRegex);
                        break;
                    case 4:
                        ngModelCtrl.$validators["number"] = patternValidator(numberRegex);
                        break;
                    case 5:
                        ngModelCtrl.$validators["date"] = dateValidator;
                        break;
                    case 6:
                        ngModelCtrl.$validators["email"] = patternValidator(emailRegex);
                        break;
                    case 7:
                        ngModelCtrl.$validators["number"] = patternValidator(currencyRegex);
                        break;
                    case 8:
                        ngModelCtrl.$validators["percentage"] = percentageValidator;
                        break;
                    case 10:
                        ngModelCtrl.$validators["timecode"] = timeCodeValidator;
                        break;
                    case 14:
                        ngModelCtrl.$validators["money"] = moneyValidator;
                        break;
                }
            };

            setupValidation();

            instanceElement.on("focus", "input", (eventObject: JQueryEventObject) => {
                $(instanceElement).parents(".rl-char-data-element-row").addClass("active");
            });

            instanceElement.on("blur", "input", (eventObject: JQueryEventObject) => {
                $(instanceElement).parents(".rl-char-data-element-row").removeClass("active");
            });

            scope.$on("$destroy", () => {
                if (rlCharDataEntityDataCtrl != null) {
                    rlCharDataEntityDataCtrl.RemoveModel(ngModelCtrl);
                }
            });

            ngModelCtrl.$modelValue = null;
            ngModelCtrl.$setViewValue(scope.charDatas);
            ngModelCtrl.$pristine = true;
            ngModelCtrl.$validate();
        },
        controller: RLCharDataElementController,
        controllerAs: "elementVM"
    };
    return directive;
}

/* controller for RLCharDataElementDirective  */
class RLCharDataElementController {

    static $inject = ["$scope", "$element", "$q", "entityService", "entityCharDataService", "aclService"];

    dataType: string;
    htmlName: string;
    hasTable: boolean;
    lovDelimiter: string;
    editMode: boolean;
    searchMode: boolean;
    entityDataCtrl: RLCharDataEntityDataController;

    constructor(private $scope: IRLCharDataElementScope, private $element: ng.IAugmentedJQuery, private $q: ng.IQService, private entityService: EntityService, private entityCharDataService: EntityCharDataService, private aclService: AclService) {
        $scope.submitted == $scope.submitted || false;
        this.dataType = "";
        this.htmlName = $scope.cmd.tagLabel;
        this.hasTable = false;
        this.searchMode = $scope.searchMode;

        var dataTypeWatchFunc = () => { return $scope.cmd != null ? $scope.cmd.dataTypeID : -1; };
        var dataTypeUpdateFunc = (newValue: number, oldValue: number) => {
            if (newValue != oldValue || _.isEmpty(this.dataType)) {
                var cmd = this.$scope.cmd;
                var dataType = "";

                switch (newValue) {
                    case Consts.CharDataTypeIDs.CharDataTypes.year:
                        dataType = "year";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.url:
                        dataType = "url";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.alphanumeric:
                        if (!cmd.charValueSourceID && cmd.tagLabel != "entity_status" && cmd.tagLabel != "entity_template") {
                            if (cmd.multipleIndicator == 1) {
                                if (cmd.maxLength >= 255) {
                                    dataType = "alphanumeric-textarea-multi";
                                } else {
                                    dataType = "alphanumeric-multi";
                                }
                            } else {
                                if (cmd.maxLength > 255) {
                                    dataType = "alphanumeric-textarea";
                                } else {
                                    dataType = "alphanumeric";
                                }
                            }
                        } else if (_.any<Models.ICharacteristicMetaDataValue>(this.$scope.charLovMetaData.listOfValues, (lov) => lov.childValues.length > 0)) {
                            // check if table is child of bulk edit, if so use a special 'modal' template
                            if (_.any($element.parents("rl-bulk-edit"))) {
                                dataType = "treelist-modal";
                            } else {
                                dataType = "treelist";
                            }
                        } else if (this.hasTable && (cmd.tagLabel == "entity_template" || cmd.tagLabel == "entity_status")) {
                            if (cmd.multipleIndicator == 1) {
                                dataType = "lov-multiple";
                            }
                            else {
                                dataType = "alphanumeric";
                            }
                        } else {
                            if (cmd.multipleIndicator == 1) {
                                dataType = "lov-multiple";
                            } else {
                                dataType = "lov";
                            }
                        }
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.numeric:
                        if (cmd.tagLabel === "entity_id") {
                            dataType = "numeric-id";
                        } else {
                            dataType = "number";
                        }
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.date:
                        if (cmd.multipleIndicator == 1) {
                            dataType = "date-multi";
                        } else {
                            dataType = "date";
                        }
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.email:
                        dataType = "email";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.currency:
                        dataType = "currency";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.percentage:
                        dataType = "percentage";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.password:
                        dataType = "password";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.timecode:
                        dataType = "timecode";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.creditcard:
                        dataType = "creditcard";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.file:
                        dataType = "file";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.checkbox:
                        dataType = "checkbox";
                        break;
                    case Consts.CharDataTypeIDs.CharDataTypes.money:
                        dataType = "money";
                        break;
                    default:
                        dataType = "";
                        break;
                }
                this.dataType = dataType;
            }
        };


        var charDataInitiallyEmpty = true;

        if (this.$scope.cmd != null) {
            this.EnsureLovData()
                .then(() => {
                    this.EnsureFirstCharData();
                    charDataInitiallyEmpty = !_.any(this.$scope.charDatas, cd => cd.recCharID > 0);
                    $scope.$watch(dataTypeWatchFunc, dataTypeUpdateFunc);
                });
        }

        if (this.$scope.cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date) {

            var checkForRecCharData = (entityID: string, charID: number): number => {
                if (this.$scope.entityID == entityID && this.$scope.cmd.characteristicID == charID) {
                    if (this.$scope.firstCharData.recCharID != 0) {
                        //console.log(`Found ${entityID} charID ${charID} recCharID ${this.$scope.firstCharData.recCharID}`);
                        return this.$scope.firstCharData.recCharID;
                    } else {
                        //console.log(`Couldn't find ${entityID} charID ${charID}`);
                    }
                }
                return null;
            };

            this.entityCharDataService.OnCheckForRecCharData(checkForRecCharData);

            this.$scope.$on("$destroy", () => {
                this.entityCharDataService.OffCheckForRecCharData(checkForRecCharData);
            });

            var createdRecCharData = (entityID: string, charID: number, recCharID: number): boolean => {
                if (this.$scope.entityID == entityID && this.$scope.cmd.characteristicID == charID) {
                    if (recCharID > 0) {
                        this.$scope.firstCharData.recCharID = recCharID;
                        this.$scope.firstCharData.value = this.$scope.firstCharData.value || Consts.DateMath.BlankDateValue;
                        //console.log(`Setting ${entityID} charID ${charID} to recCharID ${recCharID}`);
                        return true;
                    }
                }
                return false;
            };

            this.entityCharDataService.OnCreatedRecCharData(createdRecCharData);
            this.$scope.$on("$destroy", () => {
                this.entityCharDataService.OffCreatedRecCharData(createdRecCharData);
            });

        }

        var setEditMode = () => {
            var canWrite = Utils.AclUtil.hasWriteAccess(this.aclService.acls, this.$scope.cmd.acl);
            var canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, this.$scope.cmd.acl);
            this.editMode = this.$scope.searchMode ||
                (this.$scope.editMode &&
                    (
                        (canWrite && canCreate) ||
                        (canWrite && !canCreate && !charDataInitiallyEmpty) ||
                        (!canWrite && canCreate && charDataInitiallyEmpty)
                    ));
        };

        $scope.$watch(() => [this.$scope.editMode, this.$scope.createMode, charDataInitiallyEmpty],
            (newValue, oldValue) => {
                setEditMode();
            }, true);

        setEditMode();
    }

    EnsureLovData() {

        // if cmd has charValueSourceID then do a promise call before starting $watch and firstCharData
        if (this.$scope.cmd.tagLabel == "entity_status" || this.$scope.cmd.tagLabel == "entity_template") {
            //this.$scope.cmd.charValueSourceID == this.$scope.cmd.tagLabel;
            return this.entityService.getHeaderCharLovMetaData(this.$scope.cmd.charTypeID, this.$scope.cmd.tagLabel)
                .then((result) => {
                    this.$scope.charLovMetaData = result;

                    // decide the edit control type of the element

                });
        }
        else if (this.$scope.cmd.charValueSourceID) {
            return this.entityService.getCharLovMetaData(this.$scope.cmd.charValueSourceID, this.$scope.cmd.charValueSetID)
                .then((result) => {
                    this.$scope.charLovMetaData = result;
                });
        } else {
            return this.$q.when();
        }

    }

    EnsureFirstCharData() {
        // if cmd is singluar and has no values, add a first blank value for the inputs to ng-model bind to
        if (this.$scope.cmd.multipleIndicator === 0) {
            var canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, this.$scope.cmd.acl);
            // ensure user has Create ability or this is in search mode
            if (this.$scope.charDatas && (canCreate || this.$scope.searchMode) && this.$scope.charDatas.length === 0) {
                var emptyCharDataValue = { charID: this.$scope.cmd.characteristicID, recCharID: 0, value: null, valueID: null };
                // set default value only for currency LOV where CreateMode true and parentCurrencyId provided
                if (this.$scope.cmd.tagLabel == Consts.TagLabels.Currency && this.$scope.cmd.dataTypeID == 3 && this.$scope.createMode && this.$scope.parentCurrencyCharData != null && this.$scope.parentCurrencyCharData.valueID != null) {
                    var lov = _.find(this.$scope.charLovMetaData.listOfValues, (lov) => lov.characteristicValueID == this.$scope.parentCurrencyCharData.valueID);
                    if (lov != null) {
                        emptyCharDataValue.valueID = lov.characteristicValueID;
                        emptyCharDataValue.value = lov.characteristicValueLabel;
                    }
                } else if (this.$scope.cmd.requiredIndicator == 1 && this.$scope.cmd.dataTypeID == 3 && this.$scope.createMode && this.$scope.cmd.charValueSourceID && this.$scope.charLovMetaData && _.any(this.$scope.charLovMetaData.listOfValues)) {
                    var lov = _.first(this.$scope.charLovMetaData.listOfValues);
                    if (lov != null) {
                        emptyCharDataValue.valueID = lov.characteristicValueID;
                        emptyCharDataValue.value = lov.characteristicValueLabel;
                    }
                } else if (this.$scope.cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money && this.$scope.createMode) {
                    var moneyValue: Models.ICharDataMoneyValue = {};
                    if (this.$scope.parentCurrencyCharData != null && this.$scope.parentCurrencyCharData.valueID != null) {
                        moneyValue.divCur = this.$scope.parentCurrencyCharData.valueID;
                        emptyCharDataValue.value = JSON.stringify(moneyValue);
                    }
                }
                this.$scope.charDatas.push(emptyCharDataValue);
            }
        }
    }
}



RLCharDataElementHorizontalDirective.$inject = ["$q", "$log", "$timeout", "dateLocaleService", "entityService", "entityConfigService"];
export function RLCharDataElementHorizontalDirective($q: ng.IQService, $log: ng.ILogService, $timeout: ng.ITimeoutService, dateLocaleService: DateLocaleService, entityService: EntityService, entityConfigService: EntityConfigService) {

    var directive = RLCharDataElementDirective($q, $log, $timeout, dateLocaleService, entityService, entityConfigService);
    directive.template = require("/assets/app/templates/chardata/char-data-element-horizontal.html");
    directive.require = ["ngModel", "rlCharDataElementHorizontal", "^?rlCharDataTable", "^?rlCharDataEntityData"];
    directive.scope["cmd"] = "=rlCharDataElementHorizontal";
    return directive;
}

/* directive to apply rightsline jquery validation to elements based on characteristic meta data */
export function RLDataMetaValidate() {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            cmd: "=rlDataMetaValidate"
        },
        link: (scope: IRLDataMetaValidateScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var cmd = scope.cmd;
            // disable if non-editable
            if (cmd.tagLabel.indexOf("entity_") == 0 && cmd.tagLabel != "entity_title" && scope.$parent["searchMode"] !== true) {
                element.attr("disabled", "true");
                return;
            }

            // add simple length validation
            if (cmd.maxLength > 0 && !cmd.charValueSourceID) {
                element.attr("maxlength", cmd.maxLength);
            }
        }
    };
    return directive;
}

interface IRLDataMetaValidateScope extends ng.IScope {
    cmd: Models.ICharacteristicMetaData;
}


RLCharDataEntityData.$inject = ["$parse"];
export function RLCharDataEntityData($parse: ng.IParseService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "rlCharDataEntityData",
        controller: RLCharDataEntityDataController,
        controllerAs: "rcdedVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLCharDataEntityDataController) => {
            var entityDataParse = $parse(attributes["rlCharDataEntityData"]);
            controller.entityData = entityDataParse(scope);
        }
    };
    return directive;
}

export function RLCharDataTableEntityData() {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            entityData: "=rlCharDataTableEntityData",
        },
        controller: RLCharDataEntityDataController,
        controllerAs: "rcdedVM",
        bindToController: true,
        require: ["rlCharDataTableEntityData", "^rlCharDataTable"],
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLCharDataEntityDataController, RLCharDataTableController]) => {
            controllers[1].entityDataCtrl = controllers[0];
        }
    };
    return directive;
}

export class RLCharDataEntityDataController {
    static $inject = ["$scope", "entityCharDataService", "dateLocaleService", "aclService"];
    entityData: Models.ICharDataCollection;
    ngModels: { [modelName: string]: ng.INgModelController } = {};
    recCharIDsWithChildDateMath: number[];

    //Conditional Fields
    conditionalFieldRules: {
        charID: number,
        tagLabel: string,
        triggerCharID: number,
        triggerTagLabel: string,
        triggerValue: string
    }[] = [];
    visibleCharTagLabels: { [tagLabel: string]: boolean } = {};

    constructor(private $scope: ng.IScope, private entityCharDataService: EntityCharDataService, private dateLocaleService: DateLocaleService, private aclService: AclService) {

        $scope.$watch(() => {
            return this.entityData != null ? this.entityData.charDatas : {}
        }, (newValue, oldValue) => {
            this.recCharIDsWithChildDateMath = [];
            if (newValue != null) {
                _.forEach(newValue, (value, key) => {
                    _.forEach(value, (cd) => {
                        if (cd.ext != null && cd.ext.dateMath != null) {
                            _.forEach(cd.ext.dateMath.relationships, (rel) => {
                                this.recCharIDsWithChildDateMath.push(rel.parentRecCharID)
                            });
                        }
                    });
                });
            }
        }, true);

        var getDateMathCharData = () => {
            if (this.entityData != null) {
                var charDatas = _(this.entityData.templateMetaData.characteristicMetaDatas)
                    .filter(cmd => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date)
                    .map(cmd => this.entityData.charDatas[cmd.tagLabel])
                    .value();
                return _.flatten(charDatas).filter(cd => cd.ext != null && cd.ext.dateMath != null);
            } else {
                return [];
            }
        };

        this.entityCharDataService.OnGetAllDateMathCharDatas(getDateMathCharData);

        var listeners: Array<Function> = [];
        var cmdWatchInit = false;
        var charactersticMetaDataWatchFunc = (newValue: Models.ICharacteristicMetaData[], oldValue) => {
            var markinTag = "mark_in";
            var markoutTag = "mark_out";
            var clipLengthTag = "clip_length";
            cmdWatchInit = true;
            // reset any previous listeners
            _.forEach(listeners, (listener) => {
                listener();
            });

            if (this.entityData != null) {
                var cmds = this.entityData.templateMetaData.characteristicMetaDatas;

                //Setup rules for CF
                this.conditionalFieldRules = [];
                _.forEach(cmds, (cmd) => {
                    if (cmd.triggerCharID) {
                        var triggerTagLabel = _.first(_.filter(cmds, c => c.characteristicID == cmd.triggerCharID)).tagLabel;

                        this.conditionalFieldRules.push({
                            charID: cmd.characteristicID,
                            tagLabel: cmd.tagLabel,
                            triggerCharID: cmd.triggerCharID,
                            triggerTagLabel: triggerTagLabel,
                            triggerValue: cmd.triggerValue
                        });
                    }
                });

                var dateCmds = cmds.filter(cmd => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date);

                _.forEach(dateCmds, (dateTypeCharData) => {
                    var match = /(.+)_start/.exec(dateTypeCharData.tagLabel);
                    if (match != null) {
                        var startCmd = dateTypeCharData;
                        var endCmd = _.find<Models.ICharacteristicMetaData>(dateCmds, (cmd2) => { return cmd2.tagLabel == match[1] + "_end"; });
                        if (endCmd != null) {
                            var dateHashFunc = () => { return [this.entityData.charDatas[startCmd.tagLabel], this.entityData.charDatas[endCmd.tagLabel]]; };
                            var dateReCalcFunc = (newValue2: Models.ICharDataValue[][], oldValue2: Models.ICharDataValue[][]) => {
                                if (newValue2 != oldValue2) {
                                    var startChar = newValue2[0][0];
                                    var endChar = newValue2[1][0];

                                    // make sure both dates exist and neither have a datemath "blank" placeholder value
                                    if (startChar != null && endChar != null && startChar.value != Consts.DateMath.BlankDateValue && endChar.value != Consts.DateMath.BlankDateValue) {
                                        var start = this.dateLocaleService.parseStorageMoment(startChar.value);
                                        var end = this.dateLocaleService.parseStorageMoment(endChar.value);
                                        if (start.isValid() && end.isValid()) {
                                            this.ngModels[startCmd.tagLabel].params = [startCmd.label, endCmd.label];
                                            this.ngModels[startCmd.tagLabel].$setValidity("dateLessThan", end >= start);

                                            if (this.ngModels[endCmd.tagLabel]) {
                                                this.ngModels[endCmd.tagLabel].params = [startCmd.label, endCmd.label];
                                                this.ngModels[endCmd.tagLabel].$setValidity("dateGreaterThan", end >= start);
                                            }
                                        }
                                    }
                                }
                            };
                            listeners.push($scope.$watch(dateHashFunc, dateReCalcFunc, true));
                        }
                    }
                });

                var markinCmd = _.find<Models.ICharacteristicMetaData>(cmds, (cmd) => { return cmd.tagLabel == markinTag; });
                if (markinCmd != null) {
                    var markoutCmd = _.find<Models.ICharacteristicMetaData>(cmds, (cmd) => { return cmd.tagLabel == markoutTag; });
                    if (markoutCmd != null) {
                        var clipLengthCmd = _.find<Models.ICharacteristicMetaData>(cmds, (cmd) => { return cmd.tagLabel == clipLengthTag; });

                        var markHashFunc = () => {
                            //$log.info([entityData.charDatas[markinCmd.tagLabel], entityData.charDatas[markoutCmd.tagLabel], entityData.charDatas[clipLengthCmd.tagLabel]]);
                            return [this.entityData.charDatas[markinCmd.tagLabel], this.entityData.charDatas[markoutCmd.tagLabel], this.entityData.charDatas[clipLengthCmd.tagLabel]];
                        };

                        var markReCalcFunc = (newValue: Models.ICharDataValue[][], oldValue: Models.ICharDataValue[][]) => {
                            if (newValue != oldValue) {
                                var markin = newValue[0][0];
                                var markout = newValue[1][0];
                                var clipLength = newValue[2][0];

                                var start = moment(markin.value, "HH:mm:ss");
                                var end = moment(markout.value, "HH:mm:ss");
                                if (start.isValid() && end.isValid()) {

                                    this.ngModels[markinTag].$setValidity("markLessThan", end > start);
                                    this.ngModels[markoutTag].$setValidity("markGreaterThan", end > start);

                                    if (clipLength != null) {
                                        if (end > start) {
                                            var difference = moment().startOf("day").milliseconds(end.valueOf() - start.valueOf());
                                            clipLength.value = difference.format("HH:mm:ss");
                                        }
                                    }
                                }
                            }
                        };

                        // push watch listener for later destruction
                        listeners.push($scope.$watch(markHashFunc, markReCalcFunc, true));
                    }
                }

                var dateHashFunc2 = () => { return dateCmds.map((cmd) => this.entityData.charDatas[cmd.tagLabel]) };
                var dateCircularValidate = () => {
                    var charDatas = this.entityCharDataService.GetAllDateMathCharDatas(); //_.flatten(_.values<Models.ICharDataValue[]>(this.$scope.entityData.charDatas));
                    _.forEach(dateCmds, (cmd) => {
                        var cd = this.entityData.charDatas[cmd.tagLabel][0];
                        var isValid = true;
                        if (cd != null) {
                            var isCircular = Utils.DateUtil.CheckForCircularDateMathReferences(charDatas, cd.recCharID, cd.recCharID);
                            isValid = !isCircular;
                        }
                        if (this.ngModels[cmd.tagLabel]) {
                            this.ngModels[cmd.tagLabel].$setValidity("dateMathCircular", isValid);
                        }
                    });
                };
                listeners.push($scope.$watch(dateHashFunc2, dateCircularValidate, true));

                var usageQuantityCmd = _.find(cmds, (cmd) => cmd.systemIndicator == Consts.SystemIndicators.UsageQuantity);
                var usageUnitFeeCmd = _.find(cmds, (cmd) => cmd.systemIndicator == Consts.SystemIndicators.UsageUnitFee);
                var usageTotalFeeCmd = _.find(cmds, (cmd) => cmd.systemIndicator == Consts.SystemIndicators.UsageTotalFee);
                if (!_.isNull(usageQuantityCmd) && !_.isEmpty(usageQuantityCmd) && !_.isNull(usageUnitFeeCmd) && !_.isEmpty(usageUnitFeeCmd) && !_.isNull(usageTotalFeeCmd) && !_.isNaN(usageTotalFeeCmd)) {
                    var quantityHashFunc = () => {
                        if (!_.isEmpty(usageQuantityCmd) && !_.isEmpty(usageUnitFeeCmd) && !_.isEmpty(usageTotalFeeCmd)) {
                            return [this.entityData.charDatas[usageQuantityCmd.tagLabel], this.entityData.charDatas[usageUnitFeeCmd.tagLabel], this.entityData.charDatas[usageTotalFeeCmd.tagLabel]];
                        }
                    };

                    //todo we have some globization issues in the below code with parseFloat and handling of commas / decimal points
                    var usageQtyFeeReCalcFunc = (newValue: Models.ICharDataValue[][], oldValue: Models.ICharDataValue[][]) => {
                        if (newValue != oldValue) {
                            var quantity = newValue[0][0];
                            var unit = newValue[1][0];
                            var total = newValue[2][0];
                            if (!_.isNull(quantity) && !_.isNull(unit) && !_.isNull(total) && !_.isNaN(parseFloat(quantity.value))) {
                                if (!_.isNaN(parseFloat(unit.value))) {
                                    total.value = (parseFloat(quantity.value) * parseFloat(unit.value)).toFixed(2);
                                }
                                else {
                                    //unit was not a number, try to parse as json for Money data type
                                    var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(unit.value, {});
                                    moneyValue.locAmt = moneyValue.locAmt.replace(/,/g, ''); //only works for US number formats
                                    if (!_.isNaN(parseFloat(moneyValue.locAmt))) {
                                        moneyValue.locAmt = (parseFloat(moneyValue.locAmt) * parseFloat(quantity.value)).toFixed(2)
                                        total.value = JSON.stringify(moneyValue);
                                    }
                                }
                            }
                        }
                    };
                    // push watch listener for later destruction
                    listeners.push($scope.$watch(quantityHashFunc, usageQtyFeeReCalcFunc, true));
                }
            }
        };

        var charactersticDataWatchFunc = (newValue: Models.ICharDatas, oldValue) => {
            //Check the CF rules
            var tagLabels = _.keys(newValue);

            if (this.conditionalFieldRules.length == 0) {

                this.visibleCharTagLabels = tagLabels.reduce((acc, tagLabel) => {
                    acc[tagLabel] = true;
                    return acc;
                }, <_.Dictionary<boolean>>{});

                return;
            }

            _.forEach(tagLabels, (tagLabel) => {
                var tagLabelRevealed = false;

                //For each characterisitc in the entityData charData collection, see if the field has a CF rule
                var rules = _.filter(this.conditionalFieldRules, cfr => cfr.tagLabel == tagLabel);

                if (rules.length > 0) {
                    var rule = _.first(rules);

                    //Does this field have its trigger field set to the trigger value?
                    var triggerFieldCMD = newValue[rule.triggerTagLabel];
                    if (!Utils.CharUtil.isCharDataEmpty(triggerFieldCMD)) {

                        var triggerValues = triggerFieldCMD
                            .map<string>((next) => {
                                return next.valueID != null ? next.valueID.toString() : next.value;
                            })
                            .join("|");

                        //Turn everything into an array so we can do an OR compare
                        var triggerValueArray = triggerValues.split("|"); // Maybe there are pipes in the values? ¯\_(ツ)_/¯
                        var triggerRuleArray = rule.triggerValue.split("|");

                        var hasValue = triggerValueArray.some(v => triggerRuleArray.some(r => v === r));

                        if (hasValue || rule.triggerValue == "-999") {
                            //The trigger field's value is set to the rule trigger value, show the field
                            //The trigger field's value is SOMETHING (-999), show the field
                            this.visibleCharTagLabels[tagLabel] = true;
                            tagLabelRevealed = true;

                            return;
                        }
                    }

                    //If nothing is matching, clear and hide the field
                    if (!tagLabelRevealed) {
                        let charData = newValue[tagLabel];

                        if (_.any(charData)) {
                            let first = _.first(charData);
                            let meta = this.entityData.templateMetaData.characteristicMetaDatas.find(x => x.characteristicID == first.charID);
                            if (meta.dataTypeID === Consts.CharDataTypeIDs.CharDataTypes.date) {
                                // Don't remove the char records for dates because date math relationships
                                first.value = null;
                            } else {
                                // Only clear if it's not a date
                                newValue[tagLabel] = [];
                            }
                        }

                        // hide the field
                        this.visibleCharTagLabels[tagLabel] = false;
                    }
                }
                else {
                    //There's no rule, keep the characteristic visible
                    this.visibleCharTagLabels[tagLabel] = true;
                }
            });
        };

        $scope.$watch("rcdedVM.entityData.templateMetaData.characteristicMetaDatas", charactersticMetaDataWatchFunc);
        $scope.$watch(() => this.entityData != null ? this.entityData.charDatas : null, charactersticDataWatchFunc, true);

        this.$scope.$on("$destroy", () => {
            this.entityCharDataService.OffGetAllDateMathCharDatas(getDateMathCharData);

            _.forEach(listeners, (listener) => {
                listener();
            });
        });
    }

    GetEntityID() {
        return this.entityData.entityID;
    }

    GetEntityTitle() {
        var output = `Current ${this.entityData.templateMetaData.template.templateName}`;
        var titleCd = _.first(this.entityData.charDatas["entity_title"]);
        if (titleCd != null && !_.isEmpty(titleCd.value)) {
            output = titleCd.value;
        }
        return output;
    }

    GetDateMathCharDatas() {
        var output = _.cloneDeep(this.entityData);

        var cmds = this.entityData.templateMetaData.characteristicMetaDatas.filter(cmd => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date /*&& cmd.visibilityIndicator >= this.visibility*/);

        var newCharDatas: Models.ICharDatas = {};

        cmds.forEach(cmd => {
            var cd = _.first(output.charDatas[cmd.tagLabel]);
            if (cd == null) {
                newCharDatas[cmd.tagLabel] = [{ recCharID: 0, charID: cmd.characteristicID, value: "[no date value set]" }];
            } else {
                if (cd.value == Consts.DateMath.BlankDateValue) {
                    cd.value = "TBD";
                } else if (cd.value == Consts.DateMath.PerpetutityDateValue) {
                    cd.value = "Perpetuity";
                } else if (_.isEmpty(cd.value)) {
                    cd.value = "[no date value set]";
                }
                newCharDatas[cmd.tagLabel] = [cd];
            }
            newCharDatas[cmd.tagLabel][0].value = `${cmd.label} | ${newCharDatas[cmd.tagLabel][0].value}`;
        });
        output.charDatas = newCharDatas;
        return output;
    }

    GetNewDateMathTargetRecCharID(charID: number) {
        let cmd = _.find(this.entityData.templateMetaData.characteristicMetaDatas, cmd2 => cmd2.characteristicID == charID);
        let tempRecCharID = Utils.IdBuilder.getNewTempRecID();
        let charDatas = this.entityData.charDatas[cmd.tagLabel]
        let charData = _.first(charDatas);
        if (!charData) {
            // The charDataRecord is missing so let's add it
            charData = {
                charID: charID,
                recCharID: tempRecCharID,
                value: ""
            };
            charDatas.push(charData);
        } else if (charData.recCharID == 0) {
            charData.recCharID = tempRecCharID;
        }
        charData.value = charData.value || Consts.DateMath.BlankDateValue;
        return charData.recCharID;
    }

    GetContextDateMathParentRelationshipInfo(rels: Models.ICharDataExtensionDataDateMathRel[]) {

        var cds = _(this.entityData.charDatas).values<Models.ICharDataValue[]>().flattenDeep<Models.ICharDataValue>().value();
        return rels
            //.filter(rel => rel.parentRecID == -1)
            .map((rel) => ({ relID: rel.dateMathRelID, cd: _.find(cds, cd => cd.recCharID == rel.parentRecCharID) }))
            .filter(rcd => rcd.cd != null)
            .map<Models.ICharDataExtensionDataDateMathParentRelInfo>((rcd) => {
                var cmd = _.find(this.entityData.templateMetaData.characteristicMetaDatas, cmd => cmd.characteristicID == rcd.cd.charID);
                var currentValue = rcd.cd.value;
                return { dateMathRelID: rcd.relID, currentValue: currentValue, path: `${this.GetEntityTitle()} > Details > ${cmd.label}`, entityID: this.GetEntityID() };
            });
    }

    CheckSelfForCircularDateMathReferences(contextRecCharID: number, parentRecCharID: number) {
        var charDatas = _.flatten(_.values<Models.ICharDataValue[]>(this.entityData.charDatas)).filter(cd => cd.ext != null && cd.ext.dateMath != null);
        return Utils.DateUtil.CheckForCircularDateMathReferences(charDatas, contextRecCharID, parentRecCharID);
    }

    RegisterModel(control: ng.INgModelController) {
        this.ngModels[control.$name] = control;
    }

    RemoveModel(control: ng.INgModelController) {
        delete this.ngModels[control.$name];
    }
}

/* reusable function for simple template-only directives */
function RLBasicCharDataElement(template: string, replace: boolean = false) {
    var directive: ng.IDirective = {
        restrict: "A",
        template: template,
        replace: replace
    };
    return directive;
}

/* directive for currency display element */
export function RLDataDisplayPassword() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-display-password.html"), true);
}


export function RLDataDisplayFileHorizontal() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-display-file-horizontal.html"), true);
}

/* directive for file display element */
export function RLDataDisplayFile() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-file.html"),
        controller: RLDataDisplayFileController,
        controllerAs: "dfVM",
        require: ["rlDataDisplayFile", "^?rlCharDataTable"],
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var dfCtrl: RLDataDisplayFileController = controllers[0];
            var tableCtrl: RLCharDataTableController = controllers[1];
            dfCtrl.entityID = tableCtrl.GetEntityID();
        },
        replace: false
    };
    return directive;
}

/* directive for currency display element */
export function RLDataDisplayCurrency() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-currency.html"),
        controller: RLDataCurrencyController,
        controllerAs: "dcVM",
        replace: true
    };
    return directive;
}

export function RLDataDisplayNumber() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-number.html"),
        replace: true
    };
    return directive;
}

export function RLDataDisplayNumericId() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-numeric-id.html"),
        replace: true
    };
    return directive;
}

/* directive for multi-text display element */
export function RLDataDisplayMultiText() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-display-multi-text.html"), true);
}

/* directive for basic text display element */
export function RLDataDisplayText() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-text.html"),
        controller: RLDataDisplayTextController,
        controllerAs: "dtVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDataDisplayTextController) => {
            controller.htmlName = attributes["name"];
        }
    };
    return directive;
}

class RLDataDisplayTextController {
    static $inject = ['$scope'];
    showMore: boolean = false;
    showMoreExpanded: boolean = false;
    htmlName: string;
    constructor(private $scope: IRLCharDataElementScope) {
        this.$scope.$watch(() => $scope.firstCharData != null ? $scope.firstCharData.value : null,
            (newValue, oldValue) => {
                this.showMore = (newValue || "").length > 2000;
            }, true);
    }

    Toggle($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.showMoreExpanded = !this.showMoreExpanded;
    }
}

/* directive for basic percentage display element */
export function RLDataDisplayPercentage() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-display-percentage.html"), true);
}

export function RLDataDisplayDate() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-date.html"),
        controller: RLDataDisplayDateController,
        controllerAs: "ddVM",
        replace: true,
        priority: -1
    };
    return directive;
}

export function RLDataDisplayDateHorizontal() {
    var directive = RLDataDisplayDate();
    directive.template = require("/assets/app/templates/chardata/charData-display-date-horizontal.html");
    return directive;
}

class RLDataDisplayDateController {
    static $inject = ["$scope", "dateLocaleService", "dateCalcService"];

    displayValue: string;
    constructor(private $scope: IRLCharDataElementScope, private dateLocaleService: DateLocaleService, private dateCalcService: DateCalcService) {


        var getFormattedValue = (cd: Models.ICharDataValue, defaultValue: string) => {
            if (cd == null) {
                return "";
            }
            if (cd.value == Consts.DateMath.BlankDateValue) {
                return "";
            }
            var dateMoment = dateLocaleService.parseStorageMoment(cd.value);
            if (!dateMoment.isValid()) {
                return defaultValue;
            }
            if (Utils.DateUtil.IsPerpetuity(dateMoment)) {
                return "Perpetuity";
            }
            dateMoment = dateLocaleService.localizeMoment(dateMoment);
            return dateMoment.format("L");
        };

        var getDisplayValue = (cd: Models.ICharDataValue) => {
            var isMinDate: boolean = false;

            var cd = $scope.charDatas[0];

            if (cd != null && cd.ext != null && cd.ext.dateMath != null && _.any(cd.ext.dateMath.calcs)) {

                var calc = cd.ext.dateMath.calcs[0];
                if (calc.isCalc) {
                    this.displayValue = getFormattedValue(cd, "TBD");
                } else {
                    this.displayValue = getFormattedValue(cd, "");
                    if (_.isEmpty(this.displayValue)) {
                        this.displayValue = "TBD";
                    } else {
                        this.displayValue += " TBD";
                    }
                }
            } else {
                this.displayValue = getFormattedValue(cd, "");
            }
        };

        $scope.$watch<string>("firstCharData.value", (newValue, oldValue) => {
            getDisplayValue($scope.firstCharData);
        });
    }
}

/* directive for basic text display element */
export function RLDataDisplayUrl() {
    var directive = RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-display-url.html"), true);
    directive.controller = RLDataDisplayUrlController;
    directive.controllerAs = "duVM";
    return directive;
}

/* controller for RLDataDisplayUrl directive */
class RLDataDisplayUrlController {
    static $inject = ["$scope"];
    urlRegex: RegExp = /https?:\/\/.*/;
    cleanUrl: string;
    constructor($scope: IRLCharDataElementScope) {
        // clean url to ensure an absolute url
        this.cleanUrl = ($scope.firstCharData != null ? $scope.firstCharData.value : null) || "";
        if (!this.urlRegex.test(this.cleanUrl)) {
            if (this.cleanUrl) {
                this.cleanUrl = "http://" + this.cleanUrl;
            }
        }
    }
}

/* directive for file upload */
export function RLDataEditFile() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/chardata/charData-edit-file.html"),
        controller: RLDataEditFileController,
        controllerAs: "efVM"
    };
    return directive;
}

class RLDataEditFileController {
    static $inject = ["$scope"];

    pickedFiles: IFilestackPickFile[];
    concatenatedFilenames: string;
    multipleIndicator: boolean;
    fileCharDatas: Models.ICharDataValue[];

    constructor(private $scope: IRLCharDataElementScope) {
        this.multipleIndicator = this.$scope.cmd.multipleIndicator == 1;

        // blank out picked file if charDatas are switched out
        this.$scope.$watch(() => this.$scope.charDatas, (newValue, oldValue) => {
            this.pickedFiles = [];
        });

        this.$scope.$watch(() => this.pickedFiles,
            (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    this.ResetFileNameCharData(newValue); //this is the filepicker/[filename] key for the file
                }
            }, true);
    }

    ResetFileNameCharData(files: IFilestackPickFile[]) {
        var fileNames = _.pluck(files, "filename").join("|");
        var fileKey = _.pluck(files, "key").join("|");
        this.concatenatedFilenames = fileNames;

        if (this.$scope.cmd.multipleIndicator == 1 && !_.isEmpty(fileNames)) {
            _.forEach(files, (file) => {
                if (_.any(this.$scope.charDatas, (cd) => cd.value.indexOf(file.filename) >= 0)) {
                    var cmd = _.find(this.$scope.charDatas, (cd) => cd.value.indexOf(file.filename) >= 0);
                    cmd.value = file.key;
                }
                else {
                    this.$scope.charDatas.push({ charID: this.$scope.cmd.characteristicID, recCharID: 0, value: file.key, valueID: null });
                }
            });
        }
        else {
            if (this.$scope.charDatas.length > 0) {
                this.$scope.charDatas[0].value = fileKey;
            }
            else {
                this.$scope.charDatas.push({ charID: this.$scope.cmd.characteristicID, recCharID: 0, value: fileKey, valueID: null });
            }
        }

    }

    Remove(fileName: string) {
        //this.pickedFiles = null;
        this.concatenatedFilenames = null;
        _.remove(this.$scope.charDatas, (char) => { return char.value == fileName; });
        //TODO: remove from file system
    }
}

/* directive for credit card edit element */
export function RLDataEditCreditcard() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-creditcard.html"));
}

/* directive for timecode edit element */
export function RLDataEditTimecode() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-timecode.html"));
}

/* directive for password edit element */
export function RLDataEditPassword() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-password.html"));
}

/* directive for percentage edit element */
export function RLDataEditPercentage() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-percentage.html"));
}

/* directive for currency edit element */
export function RLDataEditCurrency() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-currency.html"),
        controller: RLDataCurrencyController,
        controllerAs: "dcVM"
    };
    return directive;
}

class RLDataCurrencyController {
    static $inject = ["$scope"];

    currencySymbol: string;

    constructor(private $scope: IRLCharDataElementScope) {

        $scope.$watch(() => $scope.currencySymbolCharData,
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.currencySymbol = newValue.value || "";
                }
            }, true);
    }
}


class RLDataDisplayFileController {
    static $inject = ["$scope", "documentEntityService"];
    downloadUrl: string;
    entityID: string;
    downloadUrls: { [fileName: number]: string };
    documentViewSrc: string;
    documentFileName: string;
    documentTemplateGroupID: number = Consts.TemplateGroupIDs.RightslineDocTemplateGroup;
    documentModalOpen: boolean = false;

    constructor(private $scope: IRLCharDataElementScope, private documentEntityService: DocumentEntityService) {
        this.downloadUrl = "";
        this.downloadUrls = {};
        $scope.$watch(() => this.entityID,
            (newValue, oldValue) => {
                if (newValue != null) {
                    var recID = Utils.IdBuilder.splitEntityID(this.entityID).recID;
                    if (recID > 0) {
                        this.GetFileDownloadUrl();//when is best time to call this?
                    }
                }
            });
    }

    GetFileDownloadUrl() {
        if (this.$scope.charDatas.length > 0) {
            _.forEach(this.$scope.charDatas, (cmd) => {
                var fileName = cmd.value;
                this.documentEntityService.getDownloadUrl(this.entityID, fileName)
                    .then((result) => {
                        if (result.success) {
                            this.downloadUrls[fileName] = result.data;
                        }
                    });
            });
        }
    }

    ViewDocument(fileName: string) {
        var index = fileName.lastIndexOf('/');
        if (index >= 0) {
            this.documentFileName = fileName.substring(index + 1);
        }
        else {
            this.documentFileName = fileName;
        }
        this.documentViewSrc = this.downloadUrls[fileName];
        this.documentModalOpen = true;
    }

    CloseDocModal() {
        this.documentFileName = "";
        this.documentViewSrc = Consts.PreviewLoadingPage.HtmlFile;
        this.documentModalOpen = false;
    }
}

/* directive for email edit element */
export function RLDataEditEmail() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-email.html"));
}

/* directive for date edit element */
export function RLDataEditDate() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-date.html"),
        require: ["rlDataEditDate", "?^rlCharDataEntityData", "?^rlCharDataTableEntityData"],
        controllerAs: "edVM",
        controller: RLDataEditDateController,
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLDataEditDateController, RLCharDataEntityDataController, RLCharDataEntityDataController]) => {

            var editDateCtrl = controllers[0];
            if (controllers[1] != null || controllers[2] != null) {
                controllers[0].entityDataCtrl = controllers[1] || controllers[2];
            }


            var perpDiv = $(".has-perpetuity", element);
            var valueDiv = $(".has-date", element);
            var variesByCatalogCheckbox = $(".varies-by-catalog", element);

            scope.$watch(() => editDateCtrl.perpetuity,
                (newValue, oldValue) => {
                    if (newValue) {
                        perpDiv.show();
                        valueDiv.hide();
                    } else {
                        perpDiv.hide();
                        valueDiv.show();
                    }
                });

            //This will check if the checkbox is ticked, and if so, disable the control
            if (editDateCtrl.showVariesByCatalog) {
                if (variesByCatalogCheckbox.length > 0 && (<HTMLInputElement>variesByCatalogCheckbox[0]).checked) {
                    editDateCtrl.variesByCatalogChecked = true;
                }
                else {
                    if (editDateCtrl.IsVariesChecked()) {
                        editDateCtrl.variesByCatalogChecked = true;
                    }
                    else {
                        editDateCtrl.variesByCatalogChecked = false;
                    }
                }
            }
        }
    };
    return directive;
}

export function RLDataSearchDate() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-search-date.html"),
        require: "rlDataSearchDate",
        controllerAs: "sdVM",
        controller: RLDataSearchDateController,
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDataSearchDateController) => {

            var perpDiv = $(".has-perpetuity", element);
            var valueDiv = $(".has-date", element);
            var textDiv = $(".text-field", element);
            var variesByCatalogCheckbox = $(".varies-by-catalog", element);

            //scope.$watch(() => controller.perpetuity,
            //    (newValue, oldValue) => {
            //        if (newValue) {
            //            perpDiv.show();
            //            valueDiv.hide();
            //            textDiv.hide();
            //        } else {
            //            perpDiv.hide();
            //            textDiv.hide();
            //            valueDiv.show();
            //        }
            //    });

            scope.$watch(() => controller.textMode, (newValue, oldValue) => {
                perpDiv.hide();
                if (newValue) {
                    valueDiv.hide();
                    textDiv.show();
                } else {
                    valueDiv.show();
                    textDiv.hide();
                }
            });
        }
    };
    return directive;
}

class RLDataSearchDateController {
    static $inject = ["$scope", "$q", "dateLocaleService"];

    lastValue: string;
    perpetuity: boolean;
    offerPerpetuity: boolean;
    editedDateValue: string;

    textMode: boolean = false;

    constructor(private $scope: IRLCharDataElementScope, private $q: ng.IQService, private dateLocaleService: DateLocaleService) {


        var dateRegex = /(\d{1,2}[\/\.\-]\d{1,2}[\/\.\-]\d{4})|(\d{4}[\/\.\-]\d{1,2}[\/\.\-]\d{1,2})/;

        // only show for tagLabels like *_end
        this.offerPerpetuity = $scope.cmd.tagLabel.indexOf("_end") >= 0;
        var format = "L";
        var isPerpetuity = (value: string): boolean => {
            if (value != "") {
                var date = dateLocaleService.parseStorageMoment(value);
                return this.offerPerpetuity && Utils.DateUtil.IsPerpetuity(date);
            }
            return false;
        };


        $scope.$watch(() => $scope.firstCharData != null ? $scope.firstCharData.value : null,
            (newValue, oldValue) => {
                if (newValue != null) {
                    if (dateRegex.test(newValue)) {
                        this.perpetuity = isPerpetuity(newValue);
                        var dateMoment = dateLocaleService.parseStorageMoment(newValue);
                        dateMoment = dateLocaleService.localizeMoment(dateMoment);
                        var localeDateString = dateMoment.format("L");
                        if (dateMoment.isValid() && this.editedDateValue != localeDateString) {
                            this.editedDateValue = localeDateString;
                        }
                    } else if (this.editedDateValue != newValue) {
                        this.editedDateValue = newValue;
                    }
                    if (!this.textMode && /now/i.test(newValue)) {
                        this.textMode = true;
                    }
                }
                else {
                    this.editedDateValue = newValue;
                }
            }, true);

        $scope.$watch(() => this.editedDateValue,
            (newValue, oldValue) => {
                if (newValue != null) {
                    if (this.textMode) {
                        this.$scope.firstCharData.value = newValue;
                    } else {
                        if (dateRegex.test(newValue)) {
                            var dateMoment = dateLocaleService.parseMoment(newValue);
                            if (dateMoment.isValid()) {
                                dateMoment = dateLocaleService.delocalizeMoment(dateMoment);
                                var storageDateString = dateMoment.format("L");
                                if (this.$scope.firstCharData.value != storageDateString) {
                                    this.$scope.firstCharData.value = storageDateString;
                                }
                            }
                        }
                        else if (this.$scope.firstCharData.value != newValue) {
                            this.$scope.firstCharData.value = newValue;
                        }
                    }
                }
            }, true);



    }

    PerpetuityChecked() {
        this.perpetuity = !this.perpetuity;

        if (this.perpetuity) {
            this.lastValue = this.$scope.firstCharData.value;
            this.$scope.firstCharData.value = "09/09/9999";
        } else {
            this.$scope.firstCharData.value = this.lastValue;
        }
    }


    ToggleMode(textMode: boolean) {

        var temp = this.lastValue;
        this.lastValue = this.editedDateValue;
        this.editedDateValue = temp;

        this.textMode = textMode;
        if (this.textMode && !/now/i.test(this.editedDateValue)) {
            this.editedDateValue = "NOW";
        }
    }

}


export function RLDataEditDateHorizontal() {
    var directive = RLDataEditDate();
    directive.template = require("/assets/app/templates/chardata/char-data-edit-date-horizontal.html");
    directive.require = ["rlDataEditDateHorizontal", "?^rlCharDataEntityData", "?^rlCharDataTableEntityData"];
    return directive;
}

class RLDataEditDateController {
    static $inject = ["$scope", "$q", "dateLocaleService", "entityService", "entityConfigService", "dateCalcService", "variesByCatalogService", "aclService"];

    lastValue: string;
    perpetuity: boolean;
    editedDateValue: string;

    showPanel: boolean;
    showModal: boolean = false;
    showDisabledPanel: boolean;

    disabled: boolean;


    entityDataCtrl: RLCharDataEntityDataController;

    get showAlertPanel() {
        return !this.$scope.createMode;
    }

    //Date Calc
    get hasChildDates() {
        return _.any(this.childRelationships) || _.contains(this.entityDataCtrl.recCharIDsWithChildDateMath, this.$scope.firstCharData.recCharID);
    }

    get offerPerpetuity() {
        // only show for tagLabels like *_end
        return this.$scope.cmd.tagLabel.indexOf("_end") >= 0;
    }

    childRelationships: Models.ICharDataExtensionDataDateMathRel[];
    calculatedChildrenInfoList: Models.ICharDataExtensionDataDateMathChildRelInfo[];


    showEditWarning: boolean;
    disableDateOptions: boolean;
    //--

    //Varies By Catalog
    variesByCatalogChecked: boolean;
    showVariesByCatalog: boolean;
    //--
    showDateMathToggle: boolean = true;

    constructor(private $scope: IRLCharDataElementScope, private $q: ng.IQService, private dateLocaleService: DateLocaleService, private entityService: EntityService, private entityConfigService: EntityConfigService, private dateCalcService: DateCalcService, private variesByCatalogService: VariesByCatalogService, private aclService: AclService) {

        this.showEditWarning = false;
        this.showPanel = false;
        this.showDisabledPanel = false;

        this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasWriteAccess(aclService.acls, $scope.cmd.acl);
        var dateRegex = /(\d{1,2}[\/\.\-]\d{1,2}[\/\.\-]\d{4})|(\d{4}[\/\.\-]\d{1,2}[\/\.\-]\d{1,2})/;

        var format = "L";
        var isPerpetuity = (value: string): boolean => {
            if (value != "") {
                var date = dateLocaleService.parseStorageMoment(value);
                return this.offerPerpetuity && Utils.DateUtil.IsPerpetuity(date);
            }
            return false;
        };

        this.showVariesByCatalog = this.ShowVariesByCatalogOption();
        this.showDateMathToggle = this.ShowDateMathToggle();

        $scope.$watch(() => $scope.firstCharData != null ? $scope.firstCharData.value : null,
            (newValue, oldValue) => {
                if (newValue != null) {
                    //Date Math
                    if (newValue == Consts.DateMath.BlankDateValue) {
                        newValue = "";
                    }

                    if (dateRegex.test(newValue)) {
                        this.perpetuity = isPerpetuity(newValue);

                        var dateMoment = dateLocaleService.parseStorageMoment(newValue);
                        dateMoment = dateLocaleService.localizeMoment(dateMoment);
                        var localeDateString = dateMoment.format("L");

                        var dateMomentEdited = dateLocaleService.parseMoment(this.editedDateValue);
                        dateMomentEdited = dateLocaleService.delocalizeMoment(dateMomentEdited);
                        var localeDateStringEdited = dateMomentEdited.format("L");

                        if (dateMoment.isValid() && (this.editedDateValue != localeDateString) && (localeDateString !== localeDateStringEdited)) {
                            this.editedDateValue = localeDateString;
                        }
                        else {
                            if (!dateMoment.isValid()) {
                                this.editedDateValue = newValue;
                            }
                        }
                    } else if (this.editedDateValue != newValue) {
                        this.editedDateValue = newValue;
                    }
                }
                else {
                    this.editedDateValue = newValue;
                }
            }, true);


        $scope.$watch(() => this.childRelationships, (newValue, oldValue) => { this.LoadChildrenInfo() }, true);

        $scope.$watch(() => $scope.firstCharData != null ? $scope.firstCharData.ext : null,
            (newValue, oldValue) => {
                if (newValue != null && newValue.dateMath != null) {
                    this.childRelationships = newValue.dateMath.childRelationships;
                } else {
                    this.childRelationships = [];
                }
            }, true);



        $scope.$watch(() => this.editedDateValue,
            (newValue, oldValue) => {
                if (newValue != null) {
                    if (dateRegex.test(newValue)) {
                        var dateMoment = dateLocaleService.parseMoment(newValue);
                        if (dateMoment.isValid()) {
                            dateMoment = dateLocaleService.delocalizeMoment(dateMoment);
                            var storageDateString = dateMoment.format("L");
                            if (this.$scope.firstCharData.value != storageDateString) {
                                this.$scope.firstCharData.value = storageDateString;
                            }
                        }
                    }
                    else if (this.$scope.firstCharData.value == Consts.DateMath.BlankDateValue && _.isEmpty(newValue)) {
                        // leave value as blankDataValue
                    }
                    else if (this.$scope.firstCharData.value != newValue) {
                        this.$scope.firstCharData.value = newValue;
                    }
                }
            }, true);

        $scope.$watch(() => this.variesByCatalogChecked, (newValue, oldValue) => {
            if (newValue != null) {
                if (newValue && this.variesByCatalogService.selectedFields[this.$scope.cmd.tagLabel]) {
                    this.$scope.$parent.$parent["disableControlValidation"] = true;
                } else if (this.showVariesByCatalog && !newValue) {
                    this.$scope.$parent.$parent["disableControlValidation"] = false;
                }
            }
        }, true);

        $scope.$on('requestViewAlerts', function (e) {
            $scope.$broadcast('executeViewAlerts');
        });

        $scope.$on('requestNewAlert', function (e) {
            $scope.$broadcast('executeNewAlert');
        });

        $scope.$on('requestAlertsRefresh', function (e) {
            $scope.$broadcast('executeAlertsRefresh');
        });

        $scope.$watch(() => this.dateCalcService.parentDateFields, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (_.keys(this.dateCalcService.parentDateFields).indexOf($scope.cmd.characteristicID.toString()) > -1) {
                    //This field was set as a parent for date math for another date field.
                    //Models.ICharacteristicMetaData
                    this.entityService.getEntityCharData($scope["entityID"])
                        .then((results) => {
                            var editedValue = this.editedDateValue;

                            var charDatas = results.charDatas[$scope.cmd.tagLabel]
                            $scope.$parent.$parent.$parent.$parent["entityData"].charDatas[$scope.cmd.tagLabel] = charDatas;
                            $scope.$parent.$parent.$parent.$parent["entityData"].charDatas[$scope.cmd.tagLabel][0].value = editedValue;
                        });
                }
            }
        }, true);
    }

    PerpetuityChecked($event: ng.IAngularEvent) {
        if ($event != null) {
            $event.preventDefault();
        }
        if (this.offerPerpetuity) {
            this.perpetuity = !this.perpetuity;
            if (this.perpetuity) {
                this.lastValue = this.$scope.firstCharData.value;
                this.$scope.firstCharData.value = "09/09/9999";
            } else {
                this.$scope.firstCharData.value = this.lastValue;
            }
        }
    }

    IsVariesChecked(): boolean {
        return this.variesByCatalogService.selectedFields[this.$scope.cmd.tagLabel];
    }

    VariesByCatalogChecked() {
        if (this.perpetuity) {
            this.PerpetuityChecked(null);
        }

        this.$scope.$parent.$parent.$parent["disableControlValidation"] = this.variesByCatalogService.selectedFields[this.$scope.cmd.tagLabel];
    }

    ShowVariesByCatalogOption(): boolean {
        var isRightsCharType = Utils.IdBuilder.splitEntityID(this.$scope["entityID"]).charTypeID == Consts.CharTypeIDs.right;
        var isTermDate = [5, 6].indexOf(this.$scope.cmd.systemIndicator) > -1;
        var isCreateMode = this.$scope.createMode;

        //We do not want to show Vary by options for Mock entities and their children
        var isParentMockEntity = false;
        if (this.$scope["parentEntityID"]) {
            isParentMockEntity = Utils.IdBuilder.splitEntityID(this.$scope["parentEntityID"]).charTypeID == Consts.CharTypeIDs.mock;
        }

        if (isRightsCharType && isTermDate && isCreateMode && !isParentMockEntity) {
            return true;
        }
        else {
            return false;
        }
    }

    ShowDateMathToggle(): boolean {
        var showDateMathToggle: boolean;
        if (this.$scope.bulkEdit && this.$scope.cmd.charTypeID == Consts.CharTypeIDs.usage && this.$scope.createMode) {
            showDateMathToggle = false;
        }
        else {
            showDateMathToggle = true;
        }
        return showDateMathToggle;
    }

    ToggleModal() {
        this.showModal = !this.showModal;
    }

    TogglePanel() {
        if (!this.showPanel) {
            this.LoadChildrenInfo()
                .then(() => {
                    this.showPanel = true;
                });
        } else {
            this.showPanel = false;
        }
    }

    LoadChildrenInfo() {
        if (_.any(this.childRelationships)) {
            return this.dateCalcService.getDateMathCalcChildrenInfo(this.childRelationships)
                .then((result) => {
                    this.calculatedChildrenInfoList = result.filter((info) => info.isCalculated && info.recalcOptionID > 1);
                    this.showEditWarning = _.any(this.calculatedChildrenInfoList);
                });
        } else {
            return this.$q.when();
        }
    }

}

/* directive for number edit element */
export function RLDataEditNumber() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-number.html"));
}

/* directive for single textarea edit element */
export function RLDataEditTextarea() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-textarea.html"),
        controller: RLDataEditTextareaController,
        controllerAs: "etaVM"
    };
    return directive;
}

/* controller for RLDataEditText */
class RLDataEditTextareaController {
    static $inject = ["$scope", "variesByCatalogService"];

    hasVariesByCatalog: boolean;
    showVariesByMessage: boolean;

    constructor(private $scope: IRLCharDataElementScope, private variesByCatalogService: VariesByCatalogService) {

        this.hasVariesByCatalog = false

        this.ShowVariesByCatalogMessage();

        $scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);

        $scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);
    }

    ShowVariesByCatalogMessage() {
        var isRightsCharType = Utils.IdBuilder.splitEntityID(this.$scope["entityID"]).charTypeID == Consts.CharTypeIDs.right;
        var isEntityTitle = this.$scope.cmd.tagLabel == "entity_title";
        var isCreateMode = this.$scope.createMode;
        var isParentCharTypeNotCatalogItem = Utils.IdBuilder.splitEntityID(this.$scope.parentEntityID).charTypeID != Consts.CharTypeIDs.property;

        if (isRightsCharType && isEntityTitle && isCreateMode && this.hasVariesByCatalog && isParentCharTypeNotCatalogItem) {
            this.showVariesByMessage = true;
            this.$scope.$parent.$parent["disableControlValidation"] = true;
        }
        else {
            this.showVariesByMessage = false;
            this.$scope.$parent.$parent["disableControlValidation"] = false;
        }
    }
}

/* directive for single text edit element */
export function RLDataEditText() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-text.html"),
        controller: RLDataEditTextController,
        controllerAs: "etVM"
    };
    return directive;
}

/* controller for RLDataEditText */
class RLDataEditTextController {
    static $inject = ["$scope", "variesByCatalogService", 'entityService'];

    hasVariesByCatalog: boolean;
    showVariesByMessage: boolean;
    showTypeAheadPart: boolean;
    typedName: string;
    currentIndex: number;
    resultsShown: boolean;

    constructor(private $scope: IRLCharDataElementScope, private variesByCatalogService: VariesByCatalogService, private entityService: EntityService) {

        this.hasVariesByCatalog = false
        this.resultsShown = false;
        this.ShowVariesByCatalogMessage();
        this.ShowTypeAhead();

        $scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);

        $scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);
    }

    ShowVariesByCatalogMessage() {
        var isRightsCharType = Utils.IdBuilder.splitEntityID(this.$scope["entityID"]).charTypeID == Consts.CharTypeIDs.right;
        var isEntityTitle = this.$scope.cmd.tagLabel == "entity_title";
        var isCreateMode = this.$scope.createMode;
        var isParentCharTypeNotCatalogItem = Utils.IdBuilder.splitEntityID(this.$scope.parentEntityID).charTypeID != Consts.CharTypeIDs.property;

        if (isRightsCharType && isEntityTitle && isCreateMode && this.hasVariesByCatalog && isParentCharTypeNotCatalogItem) {
            this.showVariesByMessage = true;
            this.$scope.$parent.$parent["disableControlValidation"] = true;
        }
        else {
            this.showVariesByMessage = false;
            this.$scope.$parent.$parent["disableControlValidation"] = false;
        }
    }

    ShowTypeAhead() {
        var isEntityTitle = this.$scope.cmd.tagLabel == "entity_title";
        var isCharTypeCatalogItem = this.$scope.cmd.charTypeID == Consts.CharTypeIDs.property;

        if (isEntityTitle && isCharTypeCatalogItem) {
            this.showTypeAheadPart = true;
        }
        else {
            this.showTypeAheadPart = false;
        }
    }

    Search(keyword, index) {
        this.typedName = keyword;
        this.currentIndex = index;
        if (this.typedName.length > 3) {
            //Get results based on inputed characters
            var parentCharTypeID = -1;
            var parentRecID = -1;
            if (this.$scope.parentEntityID != undefined) {
                var parentEntityID = Utils.IdBuilder.splitEntityID(this.$scope.parentEntityID);
                parentCharTypeID = parentEntityID.charTypeID;
                parentRecID = parentEntityID.recID;
            }

            return this.entityService.searchTypeAhead(this.$scope.cmd.charTypeID, this.$scope.templateID, keyword, -1, parentCharTypeID, parentRecID)
                .then((results) => {
                    this.resultsShown = true;
                    return results.resultDocs;
                });
        }
    }

    SelectTypeAhead(item) {
        //console.log(item.characteristics);   
        //console.log(this.$scope.entityData);         
    }
}

/* directive for url edit element */
export function RLDataEditUrl() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-url.html"));
}

/* directive for year edit element */
export function RLDataEditYear() {
    return RLBasicCharDataElement(require("/assets/app/templates/chardata/charData-edit-year.html"));
}

/* directive for multiple text edit element */
export function RLDataEditMultiText() {

    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-multi-text.html"),
        require: "rlDataEditMultiText",
        controller: RLDataEditMultiTextController,
        controllerAs: "emtVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDataEditMultiTextController) => {
            var newInput = element.find("input[data-newvalue]").eq(0);
            if (newInput != null) {
                newInput.bind("blur", () => {
                    controller.Add();
                });
            }
        }
    };
    return directive;
}

/* controller for RLDataEditMultiText directive */
class RLDataEditMultiTextController {
    static $inject = ["$scope"];

    // holds value for new value box
    newValue: string;

    constructor(private $scope: IRLCharDataElementScope) {
    }

    // add a new value to the list
    Add() {
        if (!_.isEmpty(this.newValue)) {
            // add new value w/ artificial hash for uniqueness
            this.$scope.charDatas.push({ _hash: _.random(10000), charID: this.$scope.cmd.characteristicID, recCharID: 0, value: this.newValue, valueID: null });
            // blank out new value input box
            this.newValue = "";
        }
    }

    // remove a value from the list
    Remove(value) {
        _.remove(this.$scope.charDatas, (char) => { return char == value; });
    }

    CaptureKeysUp(event: JQueryEventObject) {
        if (event.keyCode == 13) {
            event.preventDefault();
            this.Add();
        }
    }

    CaptureKeysDown(event: JQueryEventObject) {
        if (event.keyCode == 9) {
            if (!_.isEmpty(this.newValue)) {
                event.preventDefault();
                this.Add();
            }
        }
    }
}

export function RLDataEditMultiTextarea() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-multi-textarea.html"),
        require: "rlDataEditMultiTextarea",
        controller: RLDataEditMultiTextareaController,
        controllerAs: "emtVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDataEditMultiTextareaController) => {
            var newInput = element.find("textarea[data-newvalue]").eq(0);
            if (newInput != null) {
                newInput.bind("blur", () => {
                    controller.Add();
                });
            }
        }
    };
    return directive;
}

/* controller for RLDataEditMultiText directive */
class RLDataEditMultiTextareaController {
    static $inject = ["$scope"];

    // holds value for new value box
    newValue: string;

    constructor(private $scope: IRLCharDataElementScope) {

    }

    // add a new value to the list
    Add() {
        if (!_.isEmpty(this.newValue)) {
            // add new value w/ artificial hash for uniqueness
            this.$scope.charDatas.push({ _hash: _.random(10000), charID: this.$scope.cmd.characteristicID, recCharID: 0, value: this.newValue, valueID: null });
            // blank out new value input box
            this.newValue = "";
        }
    }

    // remove a value from the list
    Remove(value) {
        _.remove(this.$scope.charDatas, (char) => { return char == value; });
    }

    CaptureKeysUp(event: JQueryEventObject) {
        if (event.keyCode == 13) {
            event.preventDefault();
            this.Add();
        }
    }

    CaptureKeysDown(event: JQueryEventObject) {
        if (event.keyCode == 9) {
            if (!_.isEmpty(this.newValue)) {
                event.preventDefault();
                this.Add();
            }
        }
    }
}

interface IRLTagsScope extends ng.IScope {
    remove: any;
    selectedItems: any;
}

export function RLTags() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-tags.html"),
        scope: {
            selectedItems: "="
        },
        link: (scope: IRLTagsScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            scope.remove = (tag) => {
                var idx = scope.selectedItems.indexOf(tag);
                scope.selectedItems.splice(idx, 1);
            };
        }
    };

    return directive;
}

/* directive for multi-lov edit element */
export function RLDataEditLovMultiple() {

    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-lov-multiple.html"),
        controller: RLDataEditLovMultipleController,
        controllerAs: "elmVM",
        require: ["rlDataEditLovMultiple", "^?rlCharDataTable"],
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var lovCtrl: RLDataEditLovMultipleController = controllers[0];
            var tableCtrl: RLCharDataTableController = controllers[1];

            scope.$watch(() => lovCtrl.selectValues, (newValue, oldValue) => {
                if (newValue != oldValue) {

                    // find associated charValueGroups for the new charData ValueIDs
                    var triggerGroupIDs: string[] = [];
                    var triggerOldGroupIDs: string[] = [];
                    _.forEach(newValue,
                        (cmdv) => {
                            var matchingGroupIDs =
                                scope.charLovMetaData.charValueGroupAssociations[cmdv.characteristicValueID] || [];
                            if (matchingGroupIDs.length > 0) {
                                triggerGroupIDs = triggerGroupIDs.concat(matchingGroupIDs);
                            }
                        },
                        this);
                    if (oldValue.length > newValue.length && newValue.length === 0) {
                        _.forEach(oldValue,
                            (cmdv) => {
                                var matchingOldGroupIDs =
                                    scope.charLovMetaData.charValueGroupAssociations[cmdv.characteristicValueID] || [];
                                if (matchingOldGroupIDs.length > 0) {
                                    triggerOldGroupIDs = triggerOldGroupIDs.concat(matchingOldGroupIDs);
                                }
                            },
                            this);
                    }
                    if (tableCtrl != null) {
                        if (triggerGroupIDs.length > 0) {
                            // call the triggered group event with the matching group ids
                            var isEmpty = false;
                            tableCtrl.CrossCharValueGroupsTriggered(triggerGroupIDs, isEmpty);

                        }
                        if (triggerOldGroupIDs.length > 0) {
                            var isEmpty = true;
                            tableCtrl.CrossCharValueGroupsTriggered(triggerOldGroupIDs, isEmpty);
                        }
                    }
                }
            }, true);

            var crossCharValueGroupTriggeredCallback = (triggerGroupIDs: string[], isEmpty: boolean) => {
                // try to find matching charValueGroupIDs
                var matchingGroups = _.filter(scope.charLovMetaData.charValueGroups, (cvg) => _.contains(triggerGroupIDs, cvg.charValueGroupID));
                // if groups are matched, union their charValueIDs and set to tree
                if (isEmpty) {
                    lovCtrl.selectValues = [];

                }
                else if (matchingGroups.length > 0) {
                    var newValueIDs = _(matchingGroups).map((g) => g.charValueAssociations)
                        .flatten<Models.ICharacteristicValueGroupCharacteristicValueAssociation>()
                        .map(vca => vca.charValueID).unique().valueOf();
                    var newSelectValues =
                        lovCtrl.lovList.filter((lov) => _.contains(newValueIDs, lov.characteristicValueID));
                    lovCtrl.selectValues = newSelectValues;
                }
            };

            if (tableCtrl != null) {
                tableCtrl.OnCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
            }

            scope.$on("$destroy", () => {
                if (tableCtrl != null) {
                    tableCtrl.OffCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
                }
            });
        }
    };
    return directive;
}

/* controller for RLDataEditLovMultiple */
class RLDataEditLovMultipleController {

    static $inject = ["$scope", "aclService"];

    selectValues: Models.ICharacteristicMetaDataValue[];
    tempSelectValues: Models.ICharacteristicMetaDataValue[];
    lovList: Models.ICharacteristicMetaDataValue[];
    filteredLovList: Models.ICharacteristicMetaDataValue[];
    charValueGroup: Models.ICharacteristicValueGroup;
    searchQuery: string;
    disabled: boolean;

    constructor(private $scope: IRLCharDataElementScope, aclService: AclService) {

        this.searchQuery = "";
        this.tempSelectValues = [];
        var setupLovList = (lovs: Models.ICharacteristicMetaDataValue[]) => {
            this.lovList = _(lovs)
                .filter((lov) => lov.characteristicValueID > 0)
                .sortBy((lov) => lov.sequenceNumber)
                .valueOf();
        };

        if ($scope.createMode) {
            this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasCreateAccess(aclService.acls, $scope.cmd.acl);
        }
        else {
            this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasWriteAccess(aclService.acls, $scope.cmd.acl);
        }

        $scope.$watch(() => $scope.charLovMetaData.listOfValues,
            (newValue: Models.ICharacteristicMetaDataValue[], oldValue: Models.ICharacteristicMetaDataValue[]) => {
                if (newValue != oldValue) {
                    setupLovList(newValue);
                }
            }, true);

        setupLovList($scope.charLovMetaData.listOfValues);

        $scope.$watch(() => $scope.charDatas, (newValue, oldValue) => {
            if (_.some($scope.charDatas)) {
                this.filteredLovList = _.filter<Models.ICharacteristicMetaDataValue>(this.lovList, (lov) => _.all<Models.ICharDataValue>($scope.charDatas, (cd) => cd.valueID != lov.characteristicValueID));
                this.selectValues = _.filter<Models.ICharacteristicMetaDataValue>(this.lovList, (lov) => _.any<Models.ICharDataValue>($scope.charDatas, (cd) => cd.valueID == lov.characteristicValueID));
                //Sort for create/edit forms of multi-value fields
                this.selectValues = _.sortBy(this.selectValues, s => s.characteristicValueLabel);
            } else {
                this.filteredLovList = _.cloneDeep(this.lovList);
                this.selectValues = [];
            }
            this.tempSelectValues = [];
        }, true);

        // use an in-between scope value to watch for changes, update charDatas accordingly
        $scope.$watch(() => this.tempSelectValues,
            (newValue: Models.ICharacteristicMetaDataValue[], oldValue: Models.ICharacteristicMetaDataValue[]) => {
                _.forEach(newValue, (lov) => {
                    var index = _.findIndex(this.filteredLovList, (lov2) => lov2.characteristicValueID == lov.characteristicValueID);
                    if (index > -1) {
                        this.filteredLovList.splice(index, 1);
                        this.selectValues.push(lov);
                    }
                });
            }, true);

        $scope.$watch(() => this.selectValues,
            (newValue: Models.ICharacteristicMetaDataValue[], oldValue: Models.ICharacteristicMetaDataValue[]) => {
                var oldValuesSorted = _.sortBy(oldValue, s => s.characteristicValueLabel);
                var newValuesSorted = _.sortBy(newValue, s => s.characteristicValueLabel);
                if (angular.equals(newValuesSorted, oldValuesSorted)) {
                    return;
                }

                while ($scope.charDatas.length > 0) {
                    $scope.charDatas.pop();
                }

                _.forEach(this.selectValues, (lov) => {
                    $scope.charDatas.push({ charID: $scope.cmd.characteristicID, recCharID: 0, value: lov.characteristicValueLabel, valueID: lov.characteristicValueID });
                });

                this.charValueGroup = this.FindMatchingGroup(this.selectValues.map(sv => sv.characteristicValueID));
            }, true);

        this.charValueGroup = this.FindMatchingGroup($scope.charDatas.map((cd) => cd.valueID));
    }

    OnEnterKey(event: JQueryEventObject) {
        if (event.keyCode == 13) {
            var query = this.searchQuery.toLowerCase();
            var res = _.filter(this.lovList, (cmdv) => {
                return cmdv.characteristicValueLabel.toLowerCase().indexOf(query) > -1;
            });

            if (res.length == 1) {
                this.Select(res[0]);
                this.searchQuery = "";
            }
        }
    }

    Select(selectedValue: Models.ICharacteristicMetaDataValue) {
        this.tempSelectValues.push(selectedValue);
    }

    Remove(selectedValue: Models.ICharacteristicMetaDataValue) {

        var index = _.findIndex(this.selectValues, v => v.characteristicValueID == selectedValue.characteristicValueID);
        if (index > -1) {
            this.selectValues.splice(index, 1);
            this.tempSelectValues = this.selectValues;
        }

        if (_.findIndex(this.filteredLovList, lov => lov.characteristicValueID == selectedValue.characteristicValueID) == -1) {
            this.filteredLovList.push(selectedValue);
        }
        this.filteredLovList.sort((cv1, cv2) => {
            return cv1.sequenceNumber > cv2.sequenceNumber ? 1 : -1;
        });
    }

    GroupChanged() {
        if (this.charValueGroup != null) {
            this.tempSelectValues = [];
            for (var i = 0; i < this.charValueGroup.charValueAssociations.length; i++) {
                var lov = _.find(this.lovList, (lov2) => lov2.characteristicValueID == this.charValueGroup.charValueAssociations[i].charValueID);
                if (lov != null) {
                    this.tempSelectValues.push(lov);
                }
            }
        } else {
            this.tempSelectValues = [];
        }
    }

    FindMatchingGroup(selectedValueIDs: number[]) {
        var output: Models.ICharacteristicValueGroup = null;
        this.$scope.charLovMetaData.charValueGroups.forEach((group) => {
            if (_.xor(selectedValueIDs, group.charValueAssociations.map(cva => cva.charValueID)).length == 0) {
                output = group;
            }
        });
        return output;
    }
}

/* directive for single lov edit element */
export function RLDataEditLov() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-lov.html"),
        controller: RLDataEditLovController,
        controllerAs: "elVM",
        require: ["rlDataEditLov", "^?rlCharDataTable"],
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var lovCtrl: RLDataEditLovController = controllers.find(x => x instanceof RLDataEditLovController);
            var tableCtrl: RLCharDataTableController = controllers.find(x => x instanceof RLCharDataTableController);

            scope.$watch(() => lovCtrl.selectValue, (newValue, oldValue) => {
                if (newValue != oldValue) {
                    // find associated charValueGroups for the new charData ValueIDs
                    var triggerGroupIds = scope.charLovMetaData.charValueGroupAssociations[newValue] || [];

                    // call the triggered group event with the matching group ids
                    if (_.any(triggerGroupIds) && tableCtrl) {
                        tableCtrl.CrossCharValueGroupsTriggered(triggerGroupIds);
                    }
                }
            });

            var crossCharValueGroupTriggeredCallback = (triggerGroupIDs: string[]) => {
                // try to find matching charValueGroupIDs
                var matchingGroups = _.filter(scope.charLovMetaData.charValueGroups, (cvg) => _.contains(triggerGroupIDs, cvg.charValueGroupID));

                if (_.any(matchingGroups)) {
                    var newValueIDs = _(matchingGroups)
                        .map((g) => g.charValueAssociations)
                        .flatten<Models.ICharacteristicValueGroupCharacteristicValueAssociation>()
                        .map(vca => vca.charValueID)
                        .unique()
                        .valueOf();

                    // TODO: Maybe raise a warning if there is more than one value?
                    lovCtrl.selectValue = _.first(newValueIDs);
                }
            };

            if (tableCtrl) {
                tableCtrl.OnCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
            }

            scope.$on("$destroy", () => {
                if (tableCtrl) {
                    tableCtrl.OffCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
                }
            });
        }
    };
    return directive;
}

/* controller for RLDataEditLov */
class RLDataEditLovController {
    static $inject = ["$scope", "variesByCatalogService", "aclService"];

    selectValue: number;
    disabled: boolean;
    hasVariesByCatalog: boolean;
    showVariesByMessage: boolean;

    constructor(private $scope: IRLCharDataElementScope, private variesByCatalogService: VariesByCatalogService, private aclService: AclService) {
        if ($scope.createMode) {
            this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasCreateAccess(aclService.acls, $scope.cmd.acl);
        }
        else {
            if ($scope.firstCharData.value == null || $scope.firstCharData.valueID == null) {
                this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasCreateAccess(aclService.acls, $scope.cmd.acl);
            }
            else {
                this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasWriteAccess(aclService.acls, $scope.cmd.acl);
            }
        }

        this.hasVariesByCatalog = false

        this.ShowVariesByCatalogMessage();

        if (!$scope.bulkEdit && $scope.createMode && $scope.currencySymbolCharData != null &&
            $scope.currencySymbolCharData.valueID != null && $scope.cmd.systemIndicator == Consts.SystemIndicators.Currency) {
            this.disabled = true;
        }

        // use an in-between scope value to watch for changes, update charDatas accordingly
        $scope.$watch(() => this.selectValue, (newValue: number, oldValue: number) => {
            var charDataMissing = newValue != null && (!$scope.firstCharData.valueID || !$scope.firstCharData.value) || !_.any($scope.charLovMetaData.listOfValues, (val) => val.characteristicValueID == $scope.firstCharData.valueID);
            if (newValue != oldValue || charDataMissing) {
                while ($scope.charDatas.length > 1) {
                    $scope.charDatas.pop();
                }
                var lov = _.find($scope.charLovMetaData.listOfValues, (lov) => lov.characteristicValueID == newValue);
                if (lov != null) {
                    $scope.firstCharData.value = lov.characteristicValueLabel;
                    $scope.firstCharData.valueID = lov.characteristicValueID;
                } else {
                    $scope.firstCharData.value = null;
                    $scope.firstCharData.valueID = null;
                }
            }
        });

        var charDataToSelectValue = () => {
            // set initial model value
            if ($scope.firstCharData != null && $scope.firstCharData.valueID != null) {
                var firstLov = _.find<Models.ICharacteristicMetaDataValue>($scope.charLovMetaData.listOfValues, (lov) => lov.characteristicValueID == $scope.firstCharData.valueID);
                if (firstLov == null) {
                    firstLov = _.first($scope.charLovMetaData.listOfValues);
                }
                if (firstLov != null) {
                    this.selectValue = firstLov.characteristicValueID;
                }
            } else if ($scope.cmd.requiredIndicator == 1) {
                var firstLov2 = _.first($scope.charLovMetaData.listOfValues);
                if (firstLov2 != null) {
                    this.selectValue = firstLov2.characteristicValueID;
                }
            } else {
                this.selectValue = null;
            }
        };

        $scope.$watch(() => this.$scope.firstCharData,
            (newValue, oldValue) => {
                charDataToSelectValue();
            });

        $scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);

        $scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
            this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
            this.ShowVariesByCatalogMessage();
        }, true);

        charDataToSelectValue();
    }

    ShowVariesByCatalogMessage() {
        var isRightsCharType = Utils.IdBuilder.splitEntityID(this.$scope["entityID"]).charTypeID == Consts.CharTypeIDs.right;
        var isExclusivity = this.$scope.cmd.systemIndicator == 7;
        var isCreateMode = this.$scope.createMode;

        if (isRightsCharType && isExclusivity && isCreateMode && this.hasVariesByCatalog) {
            this.showVariesByMessage = true;
        }
        else {
            this.showVariesByMessage = false;
        }
    }
}

/* directive for displaying treelist fields */
export function RLDataDisplayTreelist() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-treelist.html"),
        controller: RLDataDisplayTreelistController,
        controllerAs: "dtlVM",
        replace: true
    };
    return directive;
}
/* controller for RLDataDisplayTreelist */
class RLDataDisplayTreelistController {

    static $inject = ["$scope"];

    topLov: string;
    excludedLovs: string[];
    showExcluding: boolean;
    sortedLovs: string[];

    isCreateMode: boolean;

    constructor(private $scope: IRLCharDataElementScope) {
        this.topLov = "";
        this.excludedLovs = [];
        this.sortedLovs = [];
        var listOfValues = $scope.charLovMetaData.listOfValues;

        var updateDisplayValues = (newValue: Models.ICharDataValue[]) => {
            var result = Utils.TreeUtil.GetSelectionDescription(listOfValues, newValue);
            this.excludedLovs = _.sortBy(_.unique(result.excluded));
            this.topLov = _.first(result.included) || "";
            this.sortedLovs = _.sortBy(_.unique(result.included));
            this.showExcluding = this.excludedLovs.length > 0;
        };

        $scope.$watch("charDatas", updateDisplayValues, true);
        $scope.$watch("charDatas", updateDisplayValues, false);

        this.isCreateMode = $scope.createMode;
    }

    GetJoinLovList(): string {
        if (this.sortedLovs.length == 0) {
            return "";
        }

        if (this.showExcluding) {
            return this.topLov + ' Excluding: ' + this.excludedLovs.join(' | ');
        } else {
            return this.sortedLovs.join(' | ');
        }
    }

    GetJoinLovTruncatedList(): string {
        if (this.sortedLovs.length == 0) {
            return "";
        }

        if (this.showExcluding) {
            return Utils.TreeUtil.ClipText(this.topLov + ' Excluding: ' + this.excludedLovs.join(' | '), 35, true);
        } else {
            return Utils.TreeUtil.ClipText(this.sortedLovs.join(' | '), 35, true);
        }
    }
}

/* directive for a treelist edit element */
RLDataEditTreelist.$inject = ["$timeout"];
export function RLDataEditTreelist($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        restrict: "A",
        template: (node, attributes) => {
            var template = "";
            if (attributes.isModal) {
                template = require("/assets/app/templates/chardata/charData-edit-treelist-modal.html");
            } else {
                template = require("/assets/app/templates/chardata/charData-edit-treelist.html");
            }
            return template;
        },
        controller: RLDataEditTreelistController,
        controllerAs: "etlVM",
        require: ["rlDataEditTreelist", "^?rlCharDataTable"],
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var treeCtrl: RLDataEditTreelistController = controllers[0];
            var tableCtrl: RLCharDataTableController = controllers[1];

            var variesByCatalogRadio = $(".varies-by-radio", element);

            var findMatchingGroup = (selectedValueIDs: number[]) => {
                var output: Models.ICharacteristicValueGroup = null;
                scope.charLovMetaData.charValueGroups.forEach((group) => {
                    if (_.xor(selectedValueIDs, group.charValueAssociations.map(cva => cva.charValueID)).length == 0) {
                        output = group;
                    }
                });
                return output;
            };

            treeCtrl.charValueGroup = findMatchingGroup(scope.charDatas.map((cd) => cd.valueID));

            var treeClickedCallback = (charDatas: Models.ICharDataValue[]) => {
                // find associated charValueGroups for the new charData ValueIDs
                var triggerGroupIDs: string[] = [];
                _.forEach(charDatas, (cd) => {
                    var matchingGroupIDs = scope.charLovMetaData.charValueGroupAssociations[cd.valueID] || [];
                    if (matchingGroupIDs.length > 0) {
                        triggerGroupIDs = triggerGroupIDs.concat(matchingGroupIDs);
                    }
                }, this);

                if (triggerGroupIDs.length > 0 && tableCtrl != null) {

                    // call the triggered group event with the matching group ids
                    tableCtrl.CrossCharValueGroupsTriggered(triggerGroupIDs);
                }
            }

            treeCtrl.treeClicked = treeClickedCallback;


            // whenever the charDatas change, see if there is a matching group to set (for display purposes), or any hierarchyValueGroupAssociations are matched
            scope.$watch(() => scope.charDatas, (newValue, oldValue) => {
                if (newValue != oldValue) {
                    var newGroup = findMatchingGroup(newValue.map(cd => cd.valueID));
                    treeCtrl.charValueGroup = newGroup;

                    // trigger clicked
                }
            }, true);

            var crossCharValueGroupTriggeredCallback = (triggerGroupIDs: string[]) => {
                // try to find matching charValueGroupIDs
                var matchingGroups = _.filter(scope.charLovMetaData.charValueGroups, (cvg) => _.contains(triggerGroupIDs, cvg.charValueGroupID));
                // if groups are matched, union their charValueIDs and set to tree
                if (matchingGroups.length > 0) {
                    var newValueIDs = _(matchingGroups).map((g) => g.charValueAssociations).flatten<Models.ICharacteristicValueGroupCharacteristicValueAssociation>().map(vca => vca.charValueID).unique().valueOf();
                    treeCtrl.selectedValueIDs = newValueIDs;
                    treeCtrl.ShowSelected();
                }
            };

            if (tableCtrl != null) {
                tableCtrl.OnCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
            }

            // when directive is destroyed, destroy treelist api as well.  [good practice]
            scope.$on("$destroy", () => {
                if (tableCtrl != null) {
                    tableCtrl.OffCrossCharValueGroupsTriggered(crossCharValueGroupTriggeredCallback);
                }
            });

            //This will check if the checkbox is ticked, and if so, disable the control
            if (treeCtrl.showVariesByCatalog) {
                if (variesByCatalogRadio.length > 0 && (<HTMLInputElement>variesByCatalogRadio[0]).checked) {
                    treeCtrl.variesByCatalogChecked = true;
                }
                else {
                    if (treeCtrl.IsVariesChecked()) {
                        treeCtrl.variesByCatalogChecked = true;
                    }
                    else {
                        treeCtrl.variesByCatalogChecked = false;
                    }
                }
            }
        }
    };
    return directive;
}

/* controller for RLDataEditTreelist */
class RLDataEditTreelistController {
    static $inject = ["$scope", "entityService", "variesByCatalogService"];

    modalOpen: boolean;
    filterValue: string;
    charValueGroup: Models.ICharacteristicValueGroup;

    selectedValueIDs: number[];
    selectedLOVs: Models.ICharacteristicMetaDataValue[];

    sortedCharDatas: Models.ICharDataValue[];

    showPanel: boolean;

    //Varies by Catalog
    variesByCatalog: string;
    variesByCatalogChecked: boolean;
    showVariesByCatalog: boolean;
    showClearButton: boolean;
    //--

    clickEvent = false;
    treeClicked: (charDatas: Models.ICharDataValue[]) => void;


    constructor(private $scope: IRLCharDataElementScope, private entityService: EntityService, private variesByCatalogService: VariesByCatalogService) {
        this.modalOpen = false;

        this.sortedCharDatas = [];

        // model value for filter box
        this.filterValue = "";

        this.charValueGroup = null;
        this.showPanel = false;

        this.showVariesByCatalog = this.ShowVariesByCatalogOption();

        this.showClearButton = this.variesByCatalogService.selectedDimension == $scope.cmd.tagLabel;

        $scope.$watch(() => $scope.charDatas, (newValue) => {
            var valids = _.filter(newValue, (cd) => cd.valueID != null && cd.value != null);
            this.selectedValueIDs = _.map(valids, cv => cv.valueID);
            this.sortedCharDatas = _.sortBy(valids, cv => cv.value.toLowerCase());
            this.sortedCharDatas = _.unique(this.sortedCharDatas, c => c.valueID);
        }, true);

        $scope.$watchCollection(() => this.selectedValueIDs,
            (newValue, oldValue) => {
                if (newValue) {

                    var oldValueIDs = $scope.charDatas.map(cd => cd.valueID);
                    var newValueIDs = _.difference(newValue, oldValueIDs);

                    var removed = _.remove($scope.charDatas, (cd: Models.ICharDataValue) => !_.contains(newValue, cd.valueID));

                    var newLovs: Models.ICharacteristicMetaDataValue[] = [];
                    _.foreachGraph(this.$scope.charLovMetaData.listOfValues, lov => lov.childValues, (lov) => {
                        if (_.contains(newValueIDs, lov.characteristicValueID)) {
                            newLovs.push(lov);
                        }
                    });

                    var newCharDatas: Models.ICharDataValue[] = newLovs.map(lov => { return { charID: $scope.cmd.characteristicID, recCharID: 0, value: lov.characteristicValueLabel, valueID: lov.characteristicValueID } });

                    if (newCharDatas.length > 0) {
                        Array.prototype.unshift.apply($scope.charDatas, newCharDatas);
                        if (this.clickEvent && this.treeClicked != null) {
                            this.clickEvent = false;
                            this.treeClicked($scope.charDatas);
                        }
                    }
                }
            });

        $scope.$watch(() => variesByCatalogService.selectedDimension, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue != $scope.cmd.tagLabel) {
                    $scope.$parent.$parent["disableControlValidation"] = false;
                }
            }
        }, true);


        $scope.$watch(() => this.variesByCatalogChecked, (newValue, oldValue) => {
            if (newValue != null) {
                if (newValue && this.variesByCatalogService.selectedDimension === this.$scope.cmd.tagLabel) {
                    $scope.$parent.$parent["disableControlValidation"] = true;
                }
                else {
                    $scope.$parent.$parent["disableControlValidation"] = false;
                }
            }
        }, true);
    }

    Remove(charData: Models.ICharDataValue, $event: ng.IAngularEvent) {
        $event.preventDefault();
        _.remove(this.selectedValueIDs, v => v == charData.valueID);
    }

    // clear the filter
    ClearFilter() {
        this.filterValue = "";
    }

    GroupChanged() {
        var newGroup = this.charValueGroup;
        var newValueIDs = newGroup.charValueAssociations.map(cva => cva.charValueID);
        this.clickEvent = true;
        this.selectedValueIDs = newValueIDs;
        this.TreeClicked();
        this.ShowSelected();
    }

    ShowSelected() {
        this.$scope.$broadcast(Consts.Events.TreeListShowSelected);
    }

    // open the modal
    OpenModal() {
        this.modalOpen = true;
    }

    CloseModal() {
        this.modalOpen = false;
    }

    TogglePanel() {
        this.showPanel = !this.showPanel;
    }

    IsVariesChecked(): boolean {
        return this.variesByCatalogService.selectedDimension == this.$scope.cmd.tagLabel;
    }

    VariesByCatalogChecked() {
        this.selectedValueIDs = [];
        this.sortedCharDatas = [];

        this.$scope.$parent.$parent["disableControlValidation"] = !this.$scope.$parent.$parent["disableControlValidation"];
    }

    ClearVariesByCatalog() {
        this.variesByCatalogService.selectedDimension = "";
    }

    ShowVariesByCatalogOption(): boolean {
        var isRightsCharType = Utils.IdBuilder.splitEntityID(this.$scope["entityID"]).charTypeID == Consts.CharTypeIDs.right;
        var isDimension = [1, 2, 3, 4].indexOf(this.$scope.cmd.systemIndicator) > -1;
        var isCreateMode = this.$scope.createMode;

        //We do not want to show Vary by options for Mock entities and their children
        var isParentMockEntity = false;
        if (this.$scope["parentEntityID"]) {
            isParentMockEntity = Utils.IdBuilder.splitEntityID(this.$scope["parentEntityID"]).charTypeID == Consts.CharTypeIDs.mock;
        }

        if (isRightsCharType && isDimension && isCreateMode && !isParentMockEntity) {
            return true;
        }
        else {
            return false;
        }
    }

    TreeClicked() {
        if (this.treeClicked != null) {
            this.treeClicked(this.$scope.charDatas);
        }
    }
}



export function RLDataEditCheckbox() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-checkbox.html"),
        controller: RLDataEditCheckboxController,
        controllerAs: "cbVM"
    };
    return directive;
}

class RLDataEditCheckboxController {
    static $inject = ["$scope", "$timeout", "entityService"];

    tristate: boolean;
    state: number;
    checked: boolean;

    yesLov: Models.ICharacteristicMetaDataValue;
    noLov: Models.ICharacteristicMetaDataValue;

    cdToState: (cd: Models.ICharDataValue) => number;
    stateToNextState: (state: number) => number;

    constructor(private $scope: IRLCharDataElementScope, private $timeout: ng.ITimeoutService, private entityService: EntityService) {

        this.state = this.tristate ? 0 : -1;
        this.yesLov = _.find(this.$scope.charLovMetaData.listOfValues, (lov) => lov.characteristicValueID == 1);
        this.noLov = _.find(this.$scope.charLovMetaData.listOfValues, (lov) => lov.characteristicValueID == 2);
        this.tristate = $scope.cmd.requiredIndicator == 0 && (this.yesLov != null && this.noLov != null);

        this.cdToState = (cd: Models.ICharDataValue) => {
            if (this.noLov != null) {
                if (cd == null) {
                    return 0;
                } else if (cd.valueID == this.yesLov.characteristicValueID) {
                    return 1;
                } else if (cd.valueID == this.noLov.characteristicValueID) {
                    return -1;
                } else if (this.tristate) {
                    return 0;
                } else {
                    return -1;
                }
            } else {
                if (cd == null) {
                    return 0;
                } else if (cd.valueID == this.yesLov.characteristicValueID) {
                    return 1;
                } else {
                    return 0;
                }
            }
        };

        this.stateToNextState = (state: number) => {
            if (this.noLov != null) {
                if (state == 0) {
                    // null to true
                    return 1;
                } else if (state == 1) {
                    // true to false
                    return -1;
                } else if (this.tristate) {
                    // false to null if tri-state
                    return 0;
                } else {
                    // false to true if non-tri-state
                    return 1;
                }
            } else {
                if (state == 0) {
                    return 1;
                } else {
                    return 0;
                }
            }
        };

        //initialize states
        if (!this.tristate && $scope.firstCharData.valueID == null && this.noLov != null) {
            $scope.firstCharData.value = this.noLov.characteristicValueLabel;
            $scope.firstCharData.valueID = this.noLov.characteristicValueID;
        }
        this.state = this.cdToState($scope.firstCharData);
        this.checked = this.state == 1;

        // fresh/new chardata
        $scope.$watch(() => $scope.firstCharData, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (!this.tristate && newValue.valueID == null && this.noLov != null) {
                    $scope.firstCharData.value = this.noLov.characteristicValueLabel;
                    $scope.firstCharData.valueID = this.noLov.characteristicValueID;
                }
                this.state = this.cdToState(newValue);
                this.checked = this.state == 1;
            }
        });

        $scope.$watch(() => this.state, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (this.state == 1) {
                    $scope.firstCharData.value = this.yesLov.characteristicValueLabel;
                    $scope.firstCharData.valueID = this.yesLov.characteristicValueID;
                } else if (this.state == -1) {
                    $scope.firstCharData.value = this.noLov.characteristicValueLabel;
                    $scope.firstCharData.valueID = this.noLov.characteristicValueID;
                } else {
                    $scope.firstCharData.value = "";
                    $scope.firstCharData.valueID = null;
                }
            }
        });

    }

    Changed() {
        this.state = this.stateToNextState(this.state);
        this.checked = this.state == 1;
    }
}

export function RLDataDisplayCheckbox() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-checkbox.html"),
        controller: RLDataDisplayCheckboxController,
        controllerAs: "cbVM",
        replace: true
    };
    return directive;
}

class RLDataDisplayCheckboxController {
    static $inject = ["$scope"];

    state: number;
    checked: boolean;

    constructor(private $scope: IRLCharDataElementScope) {
        if ($scope.firstCharData == null || $scope.firstCharData.valueID == null) {
            this.state = 0;
            this.checked = false;
        } else if ($scope.firstCharData.valueID == 1) {
            this.state = 1;
            this.checked = true;
        } else {
            this.state = -1;
            this.checked = false;
        }
    }

}

/* directive for date edit element */
export function RLDataEditMoney() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-money.html"),
        controllerAs: "emVM",
        controller: RLDataEditMoneyController
    };
    return directive;
}

class RLDataEditMoneyController {
    static $inject = ["$scope", "$filter", "notifyService", "currencyConversionService", "localCacheService", "aclService"];

    localCurrencyID: number;
    localAmount: string;
    localCurrencySymbol: string = "";
    divCurrencyID: number;
    divAmount: string;
    divCurrencySymbol: string;

    debouncedRecalc: Function;
    busy: boolean = false;
    validCurrencyListOfValues: Array<Models.ICharacteristicMetaDataValue> = [];

    disabled: boolean;

    constructor(private $scope: IRLCharDataElementScope,
        private $filter: ng.IFilterService,
        private notifyService: NotifyService,
        private currencyConversionService: CurrencyConversionService,
        private cacheService: LocalCacheService,
        private aclService: AclService) {

        this.debouncedRecalc = _.debounce(this.RecalcCurrency, 1000);
        var cacheKey = 'companyCurrency';

        if ($scope.createMode) {
            this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasCreateAccess(aclService.acls, $scope.cmd.acl);
        }
        else {
            if ($scope.firstCharData.value == null) {
                this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasCreateAccess(aclService.acls, $scope.cmd.acl);
            }
            else {
                this.disabled = $scope.searchMode !== true && !Utils.AclUtil.hasWriteAccess(aclService.acls, $scope.cmd.acl);
            }
        }

        this.SetupValidCurrencyOptions();

        var setUpCurrency = () => {
            if ($scope.firstCharData.value == null && $scope.charLovMetaData) {
                var companyCurrency = this.cacheService.getItem<string>(cacheKey);
                if (!companyCurrency) {
                    this.currencyConversionService.getCompanyCurrency()
                        .then((result) => {
                            this.cacheService.setItem<string>(cacheKey, result.data, moment.duration(1, 'day'));
                            var lov2 = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueLabel == result.data);
                            if (lov2 != null) {
                                this.localCurrencyID = lov2.characteristicValueID;
                            }
                        });
                } else {
                    var lov2 = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueLabel == companyCurrency);
                    if (lov2 != null) {
                        this.localCurrencyID = lov2.characteristicValueID;
                    }
                }
            }
        };

        var setValue = (value: string) => {
            if (value != null) {
                var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(value, {});
                this.localCurrencySymbol = moneyValue.locSym;
                this.localCurrencyID = moneyValue.locCur;
                this.localAmount = moneyValue.locAmt;
                this.divCurrencyID = moneyValue.divCur;
                this.divAmount = moneyValue.divAmt;
            } else {
                this.localCurrencyID = null;
                this.localAmount = null;
                this.divCurrencyID = null;
                this.divAmount = null;
                setUpCurrency();
            }
        };

        var SetLocalCurrencyID = (localCurSymbol: string) => {
            var lov = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueLabel == localCurSymbol);
            this.localCurrencyID = lov.characteristicValueID;
        };

        var SetDivCurrencyID = (divCurSymbol: string) => {
            var lov = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueLabel == divCurSymbol);
            this.divCurrencyID = lov.characteristicValueID;
        };

        $scope.$watch(() => this.$scope.firstCharData, (newValue, oldValue) => {
            if (newValue != null) {
                setValue(newValue.value);
            }
        });

        $scope.$watch(() => $scope.firstCharData.value,
            (newValue, oldValue) => {
                setValue(newValue);
            }, true);

        $scope.$watch(() => this.localCurrencyID,
            (newValue, oldValue) => {
                if (newValue != null) {
                    var lov = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueID == newValue);
                    this.localCurrencySymbol = lov ? lov.characteristicValueLabel : "";
                }
            }, true);

        $scope.$watch(() => this.divCurrencyID,
            (newValue, oldValue) => {
                if (newValue != null) {
                    var lov = _.find($scope.charLovMetaData.listOfValues, lov => lov.characteristicValueID == newValue);
                    this.divCurrencySymbol = lov ? lov.characteristicValueLabel : "";
                }
            }, true);

        $scope.$watchGroup<[number, string, number, string]>([() => this.localCurrencyID, () => this.localAmount, () => this.divCurrencyID, () => this.divAmount],
            (newValue, oldValue) => {
                var moneyValue: Models.ICharDataMoneyValue = {};

                if (!_.isEmpty(this.localAmount)) {
                    moneyValue.locAmt = this.localAmount;
                }
                if (_.isNumber(this.localCurrencyID)) {
                    moneyValue.locCur = this.localCurrencyID;
                }
                if (!_.isEmpty(this.localCurrencySymbol)) {
                    if (!_.isNumber(this.localCurrencyID)) {
                        SetLocalCurrencyID(this.localCurrencySymbol);
                        moneyValue.locCur = this.localCurrencyID;
                    }
                    moneyValue.locSym = this.localCurrencySymbol;
                }
                if (!_.isEmpty(this.divAmount)) {
                    moneyValue.divAmt = this.divAmount;
                }
                if (_.isNumber(this.divCurrencyID)) {
                    moneyValue.divCur = this.divCurrencyID;
                }
                if (!_.isEmpty(this.divCurrencySymbol)) {
                    if (!_.isNumber(this.divCurrencyID)) {
                        SetDivCurrencyID(this.divCurrencySymbol);
                        moneyValue.divCur = this.divCurrencyID;
                    }
                    moneyValue.divSym = this.divCurrencySymbol;
                }

                if (moneyValue.locAmt != null && moneyValue.locCur != null) {
                    this.$scope.firstCharData.value = _.isEmpty(moneyValue) ? null : Utils.JsonUtil.Stringify(moneyValue);
                } else {
                    this.$scope.firstCharData.value = null;
                }

            });

        setUpCurrency();

    }

    private SetupValidCurrencyOptions() {
        var charValueSourceID = this.$scope.cmd.charValueSourceID;
        var charValueSetID = this.$scope.cmd.charValueSetID;

        if (charValueSourceID) {

            var cacheKey = 'convertableCurrencyListOfValues' + '_' + charValueSourceID + '_' + charValueSetID;
            var convertableCurrencyListOfValues: Array<Models.ICharacteristicMetaDataValue> = this.cacheService.getItem<Array<Models.ICharacteristicMetaDataValue>>(cacheKey);
            if (!convertableCurrencyListOfValues) {
                this.currencyConversionService.getConvertableCurrencyListOfValues(charValueSourceID, charValueSetID).then((result) => {
                    this.validCurrencyListOfValues = result.data;
                    this.cacheService.setItem<Array<Models.ICharacteristicMetaDataValue>>(cacheKey, result.data, moment.duration(2, 'minutes'));
                });
            }
            else {
                this.validCurrencyListOfValues = convertableCurrencyListOfValues;
            }
        }

        return;
    }

    CurrencyChanged(lov: Models.ICharacteristicMetaDataValue, $event: ng.IAngularEvent) {
        $event.preventDefault();
        this.localCurrencyID = lov ? lov.characteristicValueID : null;
        this.AmountChanged();
    }

    AmountChanged() {
        this.debouncedRecalc();
    }

    RecalcCurrency() {
        var canWrite = Utils.AclUtil.hasWriteAccess(this.aclService.acls, this.$scope.cmd.acl);
        var canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, this.$scope.cmd.acl);
        if (canWrite || (canCreate && this.$scope.createMode)) {
            if (!_.isEmpty(this.localAmount) && !_.isEmpty(this.localCurrencySymbol)) {
                this.notifyService.startProgress();
                this.busy = true;
                var cleanCurrencyAmount = parseFloat(this.localAmount.replace(/[^0-9\.]/g, ""));
                this.currencyConversionService.convertToGlobalCurrency(this.localCurrencySymbol, cleanCurrencyAmount)
                    .then((result) => {
                        var lov = _.find(this.$scope.charLovMetaData.listOfValues, lov => lov.characteristicValueLabel == result.currencySymbol);
                        this.divCurrencyID = lov ? lov.characteristicValueID : null;
                        this.divAmount = result.currencyAmount.toFixed(2);
                    }, this.notifyService.errorResponseHandler)
                    .then(angular.noop, () => {
                        this.ClearDivAmount();
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                        this.busy = false;
                    });
                this.notifyService.endProgress();
            } else if (_.isEmpty(this.localCurrencySymbol)) {
                this.ClearDivAmount();
            }
        }
    }

    ClearDivAmount() {
        this.divAmount = null;
        this.divCurrencyID = null;
        this.divCurrencySymbol = null;
    }
}

/* directive for money edit element */
export function RLDataDisplayMoney() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-money.html"),
        controllerAs: "dmVM",
        controller: RLDataDisplayMoneyController,
        replace: true
    };
    return directive;
}

class RLDataDisplayMoneyController {
    static $inject = ["$scope"];

    localAmount: string;
    localCurrencySymbol: string;
    divAmount: string;
    divCurrencySymbol: string;

    constructor(private $scope: IRLCharDataElementScope) {
        $scope.$watch(() => this.$scope.firstCharData,
            (newValue, oldValue) => {
                var moneyValue: Models.ICharDataMoneyValue = Utils.JsonUtil.Parse(newValue.value, {});

                this.localAmount = moneyValue.locAmt;
                this.localCurrencySymbol = moneyValue.locSym;
                this.divAmount = moneyValue.divAmt;
                this.divCurrencySymbol = moneyValue.divSym;
            }, true);
    }

}



var rlAdminCharDirectivesModule = angular.module("rlAdminCharDirectives", ["rlAdminConsts", "rlAdminServices"]);

rlAdminCharDirectivesModule
    .directive("rlCharDataTable", RLCharDataTableDirective)
    .directive("rlCharDataElement", RLCharDataElementDirective)
    .directive("rlCharDataEntityData", RLCharDataEntityData)
    .directive("rlCharDataTableEntityData", RLCharDataTableEntityData)
    .directive("rlDataMetaValidate", RLDataMetaValidate)
    .directive("rLDataDisplayPassword", RLDataDisplayPassword)
    .directive("rlDataDisplayCurrency", RLDataDisplayCurrency)
    .directive("rlDataDisplayMultiText", RLDataDisplayMultiText)
    .directive("rlDataEditMultiTextarea", RLDataEditMultiTextarea)
    .directive("rlDataDisplayText", RLDataDisplayText)
    .directive("rlDataDisplayPercentage", RLDataDisplayPercentage)
    .directive("rlDataDisplayDate", RLDataDisplayDate)
    .directive("rlDataDisplayDateHorizontal", RLDataDisplayDateHorizontal)
    .directive("rlDataEditCreditcard", RLDataEditCreditcard)
    .directive("rlDataEditTimecode", RLDataEditTimecode)
    .directive("rlDataEditPassword", RLDataEditPassword)
    .directive("rlDataEditPercentage", RLDataEditPercentage)
    .directive("rlDataEditCurrency", RLDataEditCurrency)
    .directive("rlDataEditEmail", RLDataEditEmail)
    .directive("rlDataEditDate", RLDataEditDate)
    .directive("rlDataEditNumber", RLDataEditNumber)
    .directive("rlDataDisplayNumber", RLDataDisplayNumber)
    .directive("rlDataDisplayNumericId", RLDataDisplayNumericId)
    .directive("rlDataEditTextarea", RLDataEditTextarea)
    .directive("rlDataEditText", RLDataEditText)
    .directive("rlDataEditFile", RLDataEditFile)
    .directive("rlDataEditUrl", RLDataEditUrl)
    .directive("rlDataEditYear", RLDataEditYear)
    .directive("rlDataEditMultiText", RLDataEditMultiText)
    .directive("rlDataEditLovMultiple", RLDataEditLovMultiple)
    .directive("rlDataSearchDate", RLDataSearchDate)
    .directive("rlTags", RLTags)
    .directive("rlDataEditLov", RLDataEditLov)
    .directive("rlDataDisplayTreelist", RLDataDisplayTreelist)
    .directive("rlDataEditTreelist", RLDataEditTreelist)
    .directive("rlDataDisplayFile", RLDataDisplayFile)
    .directive("rlDataDisplayFileHorizontal", RLDataDisplayFileHorizontal)
    .directive("rlDataDisplayUrl", RLDataDisplayUrl)
    .directive("rlCharDataTableBottomTransclude", RLCharDataTableBottomTransclude)
    .directive("rlDataEditCheckbox", RLDataEditCheckbox)
    .directive("rlDataDisplayCheckbox", RLDataDisplayCheckbox)
    .directive("rlDataEditMoney", RLDataEditMoney)
    .directive("rlDataDisplayMoney", RLDataDisplayMoney)
    .directive("rlCharDataElementHorizontal", RLCharDataElementHorizontalDirective)
    .directive("rlDataEditDateHorizontal", RLDataEditDateHorizontal)
    .directive("rlDataDisplayMultiDate", RLDataDisplayMultiDate)
    .directive("rlDataEditMultiDate", RLDataEditMultiDate)

export { rlAdminCharDirectivesModule } 
